// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("Images/loginbg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "FontAwesome";
  src: url("https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/fonts/fontawesome-webfont.eot?v=4.2.0");
  src:
    url("https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/fonts/fontawesome-webfont.eot?#iefix&v=4.2.0") format("embedded-opentype"),
    url("https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/fonts/fontawesome-webfont.woff?v=4.2.0") format("woff"),
    url("https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/fonts/fontawesome-webfont.ttf?v=4.2.0") format("truetype"),
    url("https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/fonts/fontawesome-webfont.svg?v=4.2.0#fontawesomeregular") format("svg");
  font-weight: normal;
  font-style: normal;
}

.App {
  /* text-align: center; */
  /* display: flex; */
}

.App {
  width: 100vw;
  height: 100vh;
}

.required {
  color: red;
}

/*******************Login Page**************************/
/*******************Login Page**************************/
.loginBg {
  /* background-image: linear-gradient(135deg, #efe6ff 10%, #ccb0ff 100%); */
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
  background-size: 100% 100%;
  /* background: linear-gradient(180deg, #f4f8ff, #fafbff); */
  width: 100%;
  height: 100%;
}

.loginContainer {
  margin: auto 50px auto auto;
  /*box-shadow: 1px 1px 3px 0px var(--boxshadow);
  */
  box-shadow: 0 0.25rem 2.1rem rgba(133, 131, 218, 0.2);
  width: 500px;
  background: #fff;
  border-radius: 0.6rem;
  -webkit-border-radius: 0.6rem;
  -moz-border-radius: 0.6rem;
  -ms-border-radius: 0.6rem;
  -o-border-radius: 0.6rem;
  position: relative;
}

/* .loginContainer label{
    display: none;
  } */
.inputField {
  margin: 0px 0px 0px 7px;
}

.loginContainer label {
  position: relative;
  width: 100%;
}

.loginContainer label input {
  /* background-color: #333; */
  color: #353535;
  width: 100%;
  padding: 15px 05px 15px 20px;
  outline: 0;
  border: 1px solid rgba(105, 105, 105, 0.397);
  border-radius: 10px;
}

.loginContainer label input+span {
  /* color: rgba(255, 255, 255, 0.5); */
  position: absolute;
  left: 22px;
  top: 15px;
  font-size: 1.2em;
  cursor: text;
  transition: 0.3s ease;
}

.loginContainer label input:placeholder-shown+span {
  top: 12.5px;
  font-size: 0.9em;
}

.loginContainer label input:focus+span,
.loginContainer label input:valid+span {
  color: var(--lightblue);
  top: -15px;
  font-size: 0.9em;
  font-weight: 600;
  background: #fff;
  padding: 5px;
}

.viewPassword {
  top: 6px;
  right: 6px;
}

.logoDiv {
  position: absolute;
  right: 30px;
  top: -40px;
  background: #fff;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  margin: auto;
  display: flex;
  align-items: baseline;
  justify-content: center;
  padding: 9px;
  box-shadow: 0 0.25rem 2.1rem rgba(133, 131, 218, 0.2);
}

.loginlogo {
  width: 70px;
}

.loginheader {
  background-color: #f5f5f5;
  border-radius: 20px 20px 0 0;
  -webkit-border-radius: 20px 20px 0 0;
  -moz-border-radius: 20px 20px 0 0;
  -ms-border-radius: 20px 20px 0 0;
  -o-border-radius: 20px 20px 0 0;
}

.radio-button-container {
  display: flex;
  align-items: center;
  gap: 24px;
}

.radio-button {
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.radio-button__input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.radio-button__label {
  display: inline-block;
  padding-left: 30px;
  margin-bottom: 10px;
  position: relative;
  font-size: 15px;
  color: #353535;
  font-weight: 600;
  cursor: pointer;
  text-transform: uppercase;
  transition: all 0.3s ease;
}

.radio-button__custom {
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #555;
  transition: all 0.3s ease;
}

.radio-button__input:checked+.radio-button__label .radio-button__custom {
  background-color: #4c8bf5;
  border-color: transparent;
  transform: scale(0.8);
  box-shadow: 0 0 20px #4c8bf580;
}

.radio-button__input:checked+.radio-button__label {
  color: #4c8bf5;
}

.radio-button__label:hover .radio-button__custom {
  transform: scale(1.2);
  border-color: #4c8bf5;
  box-shadow: 0 0 20px #4c8bf580;
}

/*****************************************************/
.AppBox {
  width: 100%;
  display: flex;
  background: #f1f1f1;
}

header.hide {
  display: none;
}

header {
  height: 50px;
  padding: 10px;
  color: #fff;
  background-color: var(--purple);
  display: flex;
  border-radius: 5px 5px 0 0;
}

.dashboard {
  /*display: flex;
  */
  width: calc(100vw - 300px);
  background: #fff;
  margin: 10px;
  border-radius: 5px;
  /*height: 100%;
  */
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

body {
  margin: 0;
  padding: 0;
}

.userInfo {
  height: 50px;
  padding: 10px;
  color: #fff;
  background-color: var(--purple);
  border-radius: 5px 5px 0 0;
  -webkit-border-radius: 5px 5px 0 0;
  -moz-border-radius: 5px 5px 0 0;
  -ms-border-radius: 5px 5px 0 0;
  -o-border-radius: 5px 5px 0 0;
}

.userInfo span {
  border: 1px solid;
  border-radius: 100%;
  padding: 5px;
}

.overview {
  padding: 10px;
  color: #9e9e9e;
}

.sidebar {
  width: 250px;
  /* height: calc(100vh - 50px); */
  box-shadow: 0.4px 0.6px 2.8px 0.2px var(--boxshadow);
  /* overflow: auto; */
  margin: 10px 10px 10px 15px;
  background: #fff;
  border-radius: 5px;
}

.sidebarList {
  height: calc(100vh - 170px);
  width: 100%;
  padding: 0px;
  list-style-type: none;
  overflow: auto;
}

.sideListRow {
  background: #fff;
  /* border: 1px solid var(--transgray); */
  border-top: 0px;
  width: 100%;
  height: auto;
  padding: 10px 20px;
  color: var(--purple);
}

.accordion-body .sideListRow {
  padding: 10px 10px 10px 28px;
  border: 0;
}

.sideListRow a {
  text-decoration: none;
  color: #353535;
  display: block;
  font-size: 13px;
  font-weight: 600;
}

.sideListRow.active {
  background: var(--lightpurple);
  color: var(--purple);
  cursor: default;
  font-weight: bold;
}

.sideListRow.active a {
  color: var(--purple);
}

.sideListRow:hover {
  background: var(--lightpurple);
  cursor: pointer;
}

.sideListRow:hover a {
  color: var(--purple);
  font-weight: bold;
}

.sidebarList .accordion-button {
  padding: 11px 20px !important;
  font-size: 13px !important;
  border-radius: 0 !important;
  color: #353535;
  font-weight: 600;
}

.sidebarList .subAccordion .accordion-button {
  padding: 11px 20px 11px 28px !important;
}

.sidebarList .accordion-button:focus {
  box-shadow: none !important;
}

.logout {
  padding: 10px;
  font-size: 14px;
}

.contentBox {
  /* width: calc(100vw - 250px); */
  box-shadow: 1px 1px 5px 1px var(--transgray);
  margin: 10px;
  overflow: auto;
}

.Title {
  position: relative;
  width: 100%;
  color: var(--purple);
  height: 50px;
  padding: 10px 13px;
  box-shadow: 1px 1px 5px 1px var(--transgray);
  margin-bottom: 0;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.label {
  font-weight: bold;
  width: 170px;
  /* margin-right: 30px; */
}

.bookname_label {
  top: 333px;
  left: 713px;
  width: 340px;
  height: 40px;
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border: 1px solid var(--unnamed-color-707070);
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #707070;
  border-radius: 5px;
  opacity: 1;
}

.price_label {
  top: 333px;
  left: 1073px;
  width: 150px;
  height: 40px;
  /* UI Properties */
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border: 1px solid var(--unnamed-color-707070);
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #707070;
  border-radius: 5px;
  opacity: 1;
}

.inputField {
  width: 400px !important;
  margin: 10px;
}

.inputEmploy {
  width: auto !important;
}

.bookStock {
  width: 20px !important;
}

.stockTable th {
  background-color: var(--purple) !important;
  color: var(--white);
  border-style: solid !important;
}

.stockTable td {
  background-color: #e8eaf5;
  border-style: solid !important;
}

.stockTable::-webkit-scrollbar {
  width: 0.8em;
  height: 0.3em;
  display: block;
}

.checkbox_container {
  top: 174px;
  left: 623px;
  width: 300px;
  height: 858px;
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border: 1px solid var(--unnamed-color-707070);
  border: 1px solid #707070;
  border-radius: 5px;
  opacity: 1;
}

.dropdown_container {
  border: 1px solid var(--border);
  opacity: 1;
  width: 100%;
  padding: 15px;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

/* .dropdown_container label{
  display: none;
} */
.dropdown_container .custom-Dropdown {
  width: 90% !important;
}

.formDiv {
  height: calc(100vh - 90px);
  overflow: auto;
  margin-top: 2px;
}

.parentCourse {
  display: flex;
  float: right;
  border-bottom: 1px solid;
  width: 400px;
}

.parent-border-bottom {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
  color: black;
}

.formWidth {
  width: max-content;
  padding: 15px;
  max-width: 100%;
}

.radiobtn {
  border-radius: 10px !important;
  padding: 3px 10px !important;
  -o-border-radius: 20px !important;
}

.AssignCheckbox {
  flex: 1 1;
  background-color: #fff;
  border: 1px solid;
  border: width 1px;
  padding: 5px;
  justify-content: center;
  align-items: center;
  margin: 12px;
}

.addMorebtn {
  border-radius: 20px !important;
  -webkit-border-radius: 20px !important;
  -moz-border-radius: 20px !important;
  -ms-border-radius: 20px !important;
  -o-border-radius: 20px !important;
}

.submitbtn {
  border-radius: 20px !important;
  -webkit-border-radius: 20px !important;
  -moz-border-radius: 20px !important;
  -ms-border-radius: 20px !important;
  -o-border-radius: 20px !important;
  padding: 7px 20px !important;
}

.delete {
  border-radius: 20px !important;
  -webkit-border-radius: 20px !important;
  -moz-border-radius: 20px !important;
  -ms-border-radius: 20px !important;
  -o-border-radius: 20px !important;
  padding: 7px 20px !important;
}

.submitbtn a {
  color: var(--white);
  text-decoration: none;
}

.submitbtn a:hover {
  color: var(--white);
  text-decoration: none;
}

.custom-Dropdown {
  width: 400px !important;
}

.browseDiv {
  width: 400px !important;
}

.browseDiv .custom-file {
  width: 100%;
}

/*********************Header*************************/
.sidebar-toggle {
  padding: 2px 15px;
  text-decoration: none;
}

.sidebar-toggle:before {
  font-family: "FontAwesome";
  content: "\\f0c9";
  color: #fff;
  font-size: 20px;
}

/* ********display examset********* */
.activetable {
  width: 100px;
}

/********************************************/
.rightSide {
  border-left: 1px solid var(--boxshadow);
  padding: 0px !important;
}

.rightSideHeading {
  background-color: var(--purple);
  color: var(--white);
  padding: 10px;
  text-align: center;
  font-weight: bold;
}

.teacherexam {
  background-color: var(--white);
  color: var(--purple);
  font-weight: bold;
}

.dataShow {
  padding: 0 15px 10px;
  height: calc(100vh - 185px);
  overflow: auto;
  font-size: 18px;
}

.form-switch {
  padding: 0 !important;
}

.form-switch .form-check-input {
  margin-left: 0 !important;
}

/*********************Parent Course***************************/
.parentCoursedata {
  display: flex;
  font-size: 20px;
}

.parentCoursedata span {
  font-size: 14px;
  flex: 2 1;
  margin-bottom: 10px;
}

.purple {
  color: var(--purple);
}

.red {
  color: red;
}

.blue {
  color: #016fe9;
}

/**********************************/
/* Assign Books */
.Book_Info {
  width: 98%;
}

.bookinfo_btn {
  margin: 5px;
  padding: 2px 14px !important;
}

.bookinfo_label1 {
  flex: 2 1;
  margin: 2px;
}

.bookinfo_label2 {
  flex: 1 1;
  margin: 5px;
}

.MuiSelect-select {
  padding: 9px !important;
  font-size: 14px !important;
  padding-right: 30px !important;
}

.bookAssignCustom .custom-Dropdown {
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
}

.checkVal {
  margin-left: 10px;
}

/* *************CreateSub Category******************** */
.SubCategory_radiobtn {
  padding: 10px;
}

/**************Add Book*******************/
.browselabel {
  background-color: var(--purple);
  color: white;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  width: 48px;
  text-align: center;
  font-size: 32px;
  margin: 0 10px;
}

.removelable label {
  display: none;
}

/********************Create Main Category************************/
.rightSide .custom-Dropdown {
  width: 100% !important;
}

.dropdownDiv .d-flex {
  width: 100%;
}

/* *****************create coupon code********************* */
tr:nth-child(even) {
  background: var(--lightpurple);
}

tr:nth-child(odd) {
  background: #fff;
}

td,
th {
  padding: 12px 5px;
  border-width: 1px !important;
  border-style: none !important;
}

th {
  background-color: var(--purple);
  color: var(--white);
}

table {
  border: 1px solid var(--transgray);
  /* font-size: 12px;   */
}

.customTableWithoutBg tr {
  background: transparent !important;
}

/* .r1{
  border: 1px solid red;
  color: #000;
} */

.t.r1 {
  border: 2px solid black;
}

.performanceTable th {
  /* background-color: #e6e3e3; */
  background-color: var(--purple) !important;
  color: var(--white);
  border-style: solid !important;
}

.performanceTable td {
  background-color: #e8eaf5;
  border-style: solid !important;
}

.issue th {
  background-color: var(--red);
  color: var(--white);
}

.customSelect {
  width: 100%;
}

.font-10 {
  font-size: 10px !important;
}

.font {
  font-size: xx-small !important;
}

/* ********************Create Exam Set********************* */
.examSet-dashboard {
  display: flex;
}

.examSetRadio {
  display: flex;
}

/* *************display exam set*************** */
.leftSideExam {
  padding: 0px !important;
  height: max-content;
  margin-left: 30px;
}

.rightSideExam {
  padding: 0px !important;
  height: max-content;
  margin-left: 50px;
}

/* ****************Copy Exam Set****************** */
.examdropdown {
  width: 500px;
}

/* *********************Add Question Yes*********************** */
.question-label {
  font-weight: bold;
}

.question-border {
  border: 1px solid;
  display: flex;
  justify-content: space-between;
  margin-left: 20px;
  border-color: #707070;
}

.question-title {
  font-weight: bolder;
}

.section-subtitle {
  background-color: var(--purple);
  text-align: center;
  width: 150px;
  color: var(--white);
  -webkit-margin-start: 20px;
}

.sectionleft {
  margin-left: 78px;
}

/* .blackQuestion{
  height: 50px;
  padding: 10px 27px;
  font-weight: bold;
 
  padding: 10px;

} */
.correctOption-check {
  background-color: var(--white);
  width: 150px;
  text-decoration: var(--purple) !important;
}

.subjectD {
  width: 200px;
  padding: 6px;
  margin-left: 50px !important;
}

.add_Question-btn {
  border-radius: 20px !important;
  -webkit-border-radius: 20px !important;
  -moz-border-radius: 20px !important;
  -ms-border-radius: 20px !important;
  -o-border-radius: 20px !important;
}

.add_Question-btn a {
  color: var(--blue);
  text-decoration: none;
}

.add_Question-btn a:hover {
  color: var(--white);
  text-decoration: none;
}

.quesdesctype {
  position: absolute;
  right: 10px;
  top: 39px;
  background: #fff;
  color: #9e9e9e;
  z-index: 10;
  padding: 6px 9px;
  font-size: 12px;
  box-shadow: 1px 2px 5px 1px var(--transgray);
}

.addInputbtn {
  background: transparent;
  border: 1px solid #fff;
  color: #fff;
}

/* ***************Create Section**************** */
.testInput {
  width: 300px !important;
  margin: 10px;
}

/* .editor_content{
  height:fit-content;
} */
.sectioncontainer {
  flex: 1 1;
  background-color: #fff;
  border: 1px solid;
  border: width 1px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  margin: 12px;
  margin-top: 5px !important;
  height: auto;
}

.sectioncontainerSubContainer {
  flex: 1 1;
  background-color: #fff;
  border: 1px solid;
  border: width 1px;
  width: fit-content;
  padding: 10px;
  justify-content: center;
  align-items: center;
  margin: 20px;
  padding: 10px;
  margin-top: 5px !important;
  height: auto;
}

.section-btn {
  border-radius: 20px !important;
  -webkit-border-radius: 20px !important;
  -moz-border-radius: 20px !important;
  -ms-border-radius: 20px !important;
  -o-border-radius: 20px !important;
}

.section-btn a {
  color: var(--blue);
  text-decoration: none;
}

.section-btn a:hover {
  color: var(--white);
  text-decoration: none;
}

.sectionFormDiv {
  height: calc(100vh - 122px);
  overflow: auto;
}

.sectionFormWidth {
  width: 100%;
  padding: 15px;
}

.sectionSubTitles {
  font-weight: bold !important;
}

.CreateQuestionTitle {
  position: relative;
  width: 100%;
  color: var(--purple);
  height: 50px;
  padding: 10px 27px;
  font-weight: bold;
  background-color: var(--purple);
  color: var(--white);
  padding: 10px;
  margin-top: 15px;
}

.NewOpt {
  background-color: #353535;
  color: #ffffff;
}

/* .sectionTotal{
  width:60%;
} */
/* .mycasa-grand{
  width:200px;
} */
.section-second {
  width: 100px;
  display: flex;
  justify-content: space-around;
  padding: 4px;
}

.mycasa {
  font-weight: bold;
}

.mycasa-input {
  margin-left: 1rem;
  padding: 4px;
}

/* ***************Create package Category************************* */
.session_flag {
  border: 1px solid var(--border);
  padding: 5px;
}

.datepicker {
  margin: 5px 0;
}

.datepicker fieldset {
  display: none !important;
}

.datepicker .MuiFormControl-root {
  border: 1px solid var(--border);
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

.datepicker input {
  padding: 5px 14px;
  font-size: 14px;
}

/* ******************Admit Card Creation****************** */
.admitcardcontainer {
  background-color: #fff;
  border: 1px solid;
  border: width 1px;
  padding: 10px;
}

.admitCardHeading {
  text-align: left;
  font-weight: bold;
}

.admitCardTitle {
  position: relative;
  width: 100%;
  color: var(--purple);
  height: 50px;
  padding: 10px 27px;
  margin-bottom: 0;
  font-weight: bold;
  background-color: var(--purple);
  color: var(--white);
  padding: 10px;
}

.addInput {
  border-radius: 20px !important;
  display: flex;
  justify-content: flex-end;
  -webkit-border-radius: 20px !important;
  -moz-border-radius: 20px !important;
  -ms-border-radius: 20px !important;
  -o-border-radius: 20px !important;
  text-decoration-color: white;
}

.admitcardInputMain {
  display: flex;
  justify-content: space-between;
}

.admitcardInput {
  width: 10px;
}

/* **************Recorded video*************** */
.Recorded_video {
  border: 1px solid;
  display: flex;
  justify-content: space-between;
  margin-left: 200px;
  border-color: #707070;
  width: 400px;
}

.time {
  border: 1px solid #ced4da;
  padding: 4px;
}

.time:focus-visible {
  color: #212529;
  background-color: #fff;
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 25%);
}

/* ********************ASSIGN TEACHER******************* */
.TeacherDropdown {
  width: 200px;
  padding: 6px;
  margin-left: 50px !important;
}

/* **************** I Support****************** */
.liveSchedule {
  border-radius: 20px !important;
  -webkit-border-radius: 20px !important;
  -moz-border-radius: 20px !important;
  -ms-border-radius: 20px !important;
  -o-border-radius: 20px !important;
}

.CourseSupport {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
  min-height: 40px;
  padding: 4px 27px;
  background-color: #e8eaf5;
  box-shadow: 1px 1px 5px 1px var(--lightpurple);
  margin-top: 20px;
  font-weight: bold;
}

@media screen and (max-width: 576px) {
  .CourseSupport {
    padding: 4px 12px;
  }
}

.paginateno .MuiTablePagination-toolbar {
  min-height: 40px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.CourseTableSupport {
  display: flex;
  justify-content: space-between;
  height: 50px;
  padding: 10px 27px;
  background-color: #3f51b5;
  box-shadow: 1px 1px 5px 1px var(--lightpurple);
  margin-top: 30px;
  font-weight: bold;
}

.momHeader {
  height: 50px;
  padding: 10px;
  color: #fff;
  background-color: var(--purple);
}

.mombg {
  background: #f7f7fd;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.bookBox {
  width: 450px;
}

.bookimg {
  width: 60px;
  margin: 7px;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

/******************************************/
.natoption .MuiSelect-select {
  padding: 4px !important;
}

/* /******************************** */

.sidebar .accordion-button:not(.collapsed)::after {
  transform: rotate(45deg) translate(0px, 0) !important;
  -webkit-transform: rotate(45deg) translate(0px, 0) !important;
  -moz-transform: rotate(45deg) translate(0px, 0) !important;
  -ms-transform: rotate(45deg) translate(0px, 0) !important;
  -o-transform: rotate(45deg) translate(0px, 0) !important;
}

/* .accordion-button:after {
  background-image: none !important;
  border-top: 5px solid transparent;
  border-left: 8px solid #9e9e9e;
  border-bottom: 5px solid transparent;
  width: 10px !important;
  height: 10px !important;
} */
.sidebar .accordion-button:after {
  background-image: none !important;
  border: solid #9e9e9e;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  width: 7px;
  height: 7px;
}

/*****************Support***********************/
.statusbtn {
  width: max-content;
  margin: auto;
}

.btn-div {
  font-size: 15px;
  font-weight: lighter;
  color: #008000;
  border: 1px solid #008000;
  border-radius: 20px;
  padding: 5px;
  margin-right: 10px;
  cursor: pointer;
}

.btn-div:hover {
  background-color: #008000;
  color: #ffffff;
}

.number-div {
  background-color: #008000;
  color: #ffffff;
  font-size: 14px;
  height: 20px;
  padding: 2px 5px;
  border-radius: 50%;
  position: absolute;
  right: 3px;
  top: -10px;
}

.unreadcount {
  position: absolute;
  top: -10px;
  right: 14px;
  padding: 2px 5px;
  /* width: 20px;
  height: 20px; */
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  color: #fff;
  /* padding-left: 5px; */
}

/**************************Transction Edutech*******************************/
.userDetailHeading {
  background: var(--purple);
  color: var(--white);
}

.headlabel {
  width: 250px;
  display: inline-block;
}

.removeButton {
  position: absolute;
  right: -44px;
  top: -15px;
}

.removeButton2 {
  position: absolute;
  right: -12px;
  top: 0;
}

.closeBtn {
  position: absolute;
  right: 93px;
  top: 0;
}

.closePressMediaBtn {
  position: absolute;
  right: 314px;
  top: 0;
}

.closeIfasEventBtn {
  position: absolute;
  right: 341px;
  top: 0;
}

/************************Custom Checkbox****************************/
.roundedCheckBox {
  display: flex;
  position: relative;
  padding-left: 20px;
  /* margin-bottom: 12px; */
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.roundedCheckBox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 3px;
  left: 0;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  /* background-color: #ccc; */
  border: 1px solid #707070;
}

/* On mouse-over, add a grey background color */
.roundedCheckBox:hover input~.checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.roundedCheckBox input:checked~.checkmark {
  /* background-color: #2196f3; */
  background-color: #0d6efd;
  border: none;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.roundedCheckBox input:checked~.checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.roundedCheckBox .checkmark:after {
  left: 2px;
  top: 2px;
  width: 10px;
  height: 10px;
  border: solid white;
  border-radius: 50%;
  border-width: 3px 3px 3px 3px;
  /* -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg); */
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
}

/***********************OnlineTestSeries*****************************/
.questionimg {
  aspect-ratio: 16/9;
  width: 70px;
}

.changePasswordBtn {
  margin-top: 11px;
  width: 174px;
  height: 36px;
  margin-left: 93px;
}

/* ***************stock Management************************* */

.dateStyle {
  margin-left: 90px;
}

/**************Drag n Drop***************/
.dragndropContainer {
  height: 90vh;
  width: 80vw;
  margin: 0 auto;
  padding: 10px;
  display: flex;
  justify-content: space-evenly;
}

.small-box {
  width: 48%;
  box-shadow: 1px 2px 5px 0px gray;
  height: calc(100vh - 10vh);
  overflow: auto;
  padding: 10px;
}

.task {
  border: 1px solid white;
  margin: 10px;
  box-shadow: 1px 1px 4px gray;
  /* height: 8vh; */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.dragged {
  background-color: rgba(200, 200, 200, 0.3);
  opacity: 0.5;
  cursor: pointer;
}

.dragged-over {
  background: rgba(255, 0, 0, 0.2);

  .task {
    background: rgba(255, 0, 0, 0.1);
  }
}

.orderHistoryPopupimg {
  width: 100%;
  max-width: 500px;
}

.SubContainer {
  width: max-content;
}

.add-more-Box {
  border: solid 1px #000;
  border-radius: 0;
}

.uvName {
  width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.chart-Box {
  box-shadow: 0 0px 7px -3px #b5b5b5;
  padding: 30px;
  margin: 25px;
}

/***********************CXO Dashboard*****************************/

.cardBox {
  flex: 1 1 209px;
  font-size: 1.2em;
  border: 1px solid var(--blue);
  padding: 15px 12px;
  margin: 10px;
  background: #fff;
  flex-direction: column;
  align-items: center;
  max-width: 210px;
}

.cardBox.active {
  border-color: #016fe9 !important;
}

.count {
  color: var(--blue);
}

/************************** CRM completeLeadDetail Page***************************************/
.leaddetails {
  height: calc(100vh - 60px);
  overflow: hidden;
}

.leaddetails input {
  font-size: 12px !important;
}

.leaddetails .CustomDropDown .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
  line-height: 2em !important;
}

.leaddetails .CustomDropDown .MuiSelect-select {
  font-size: 12px !important;
}

.boxshadow {
  box-shadow: 0px 2px 10px 2px #0000000d;
}

.detailsdiv {
  height: calc(100vh - 90px);
  overflow: auto;
}

.inventoryImport img {
  width: 27px !important;
  height: 26px !important;
  margin-bottom: -7px;
}

.tabheader {
  background-color: var(--purple);
  color: var(--white);
}

.input-border {
  height: 50vh;
  overflow-y: auto;
}

/*******Support Number**************/
#inputGroupSelect01 {
  width: 50px;
  /* Adjust the width as needed */
}

.form-select {
  width: 10px;
}

/* ************New CSS************ */

.contentScrollbar::-webkit-scrollbar,
.contentScrollbar .ReactVirtualized__Grid::-webkit-scrollbar {
  display: block;
  width: 0.3em;
}

.react-datepicker {
  font-family: Arial, Helvetica, sans-serif;
}

.react-datepicker__header {
  background-color: #4a90e2;
  color: #fff;
}

.react-datepicker__current-month,
.react-datepicker__year {
  font-weight: bold;
}

.react-datepicker__navigation--previous,
.react-datepicker__navigation--next {
  border: 7px solid transparent;
}

.react-datepicker__navigation--previous {
  border-right-color: #fff;
  margin-left: 10px;
}

.react-datepicker__navigation--next {
  border-left-color: #fff;
  margin-right: 10px;
}

.react-datepicker__year-text--selected,
.react-datepicker__year-text--keyboard-selected {
  background-color: #4a90e2;
  color: #fff;
}

.react-datepicker__year-text:hover {
  background-color: #4a90e2;
}

/* Style the placeholder text */
.year-picker::placeholder {
  color: #aaa;
  font-style: italic;
}

/* Custom styles for the year picker input */
.year-picker {
  width: 200px;
  padding: 7px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  color: #333;
}

.otpBox input {
  width: 60px !important;
  height: 60px !important;
  border-radius: 5px;
  border: 2px solid #ced4da;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

.otpBox input:focus-visible {
  outline: 0px;
  border-color: #86b7fe;
  color: var(--blue);
  font-weight: bolder;
  box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 25%);
}

.bagdeColor {
  background: #ff3b30;
}

.totalOrderDiv {
  background: #fdfbdf;
}

.divtext {
  color: #ff3b30;
}

.totalLeadDiv {
  background: #ffeaea;
}

.phdDiv {
  background: #efffe1;
}

.mscDiv {
  background: #e4fdff;
}

.ugcDiv {
  background: #feeaff;
}

/* Canvas Js Link removed */
.canvasjs-chart-credit {
  display: none;
}

.ugcDiv {
  background: #feeaff;
}

/* /////////////////////////// */
.coustomlable {
  width: 0px;
}

/* ******************INFLUENCER DASHBOARD*************** */
.levelsize {
  width: 100%;
  max-width: 270px;
}

.levelbg {
  background-color: #f7bded14;
  border-radius: 10px;
  position: relative;
}

.currentbenefitbg {
  background-color: #abc6e721;
  border-radius: 10px;
  height: 100%;
  max-height: 300px;
  padding: 20px;
}

.futurebenefitbg {
  background-color: #b3fdbe24;
  border-radius: 10px;
  height: 100%;
  max-height: 300px;
  padding: 20px;
}

.couponplace {
  position: absolute;
  right: 0px;
}

.performcard {
  background-color: white;
  border-radius: 5px;
  height: 100%;
  max-height: 150px;
  width: 100%;
  max-width: 250px;
}

/* ******************RATING Component*************** */

.bronze {
  background-color: #cd7f32;
}

.silver {
  background-color: #c0c0c0;
}

.gold {
  background-color: #ffd700;
}

.platinum {
  background-color: #969696;
}

.left-section {
  flex: 2 1;
}

.right-section {
  flex: 1 1;
  /* Takes 1/3 of the available space */
  border: 1px solid #ccc;
  padding: 15px;
  border-radius: 8px;
  background-color: #f9f9f9;
  overflow-y: auto;
  /* Adds scroll for overflow */
  max-height: 80vh;
  /* Adjust the height as needed */
}

.card-container {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 10px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* Space between cards */
}

.orderAnalysisSumCard {
  border-radius: 15px;
  box-shadow: 0px 13px 15px 0px #efececab;
  text-align: center;
  color: #6c757d;
}

.pdf-Uploaded {
  width: 80px;
  height: 80px;
  border: 2px dashed #cfd1d2;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #f9f9f9;
  margin: 15px 0;
}

.pdf-Uploaded:hover {
  border-color: #0d47a1;
  background-color: #e3f2fd;
}

.pdf-Uploaded img {
  width: 75px;
  height: 75px;
  object-fit: contain;
}

.pdf-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* *************************SUNDAY TEST ANALYSIS CSS************************* */

.sundayAnalysisProgressCircle {
  width: 100%;
  max-width: 77px;
}

.progressCircleColor1 .CircularProgressbar-path {
  stroke: var(--green) !important;
}

.progressCircleColor2 .CircularProgressbar-path {
  stroke: var(--red) !important;
}

.progressCircleColor1 .CircularProgressbar-text,
.progressCircleColor2 .CircularProgressbar-text {
  fill: var(--black) !important;
  font-weight: bold;
}

.circleBelowText {
  font-size: 12px;
  font-weight: bold;
}

/* *************************Refund Payment CSS************************* */
.modern-tab-wrapper {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  background: #dce6ff;
  border-radius: 30px;
  padding: 4px;
  width: fit-content;
  max-width: 100%;
  gap: 6px;
}

.modern-tab {
  flex-shrink: 0;
  padding: 8px 24px;
  font-size: 13px;
  font-weight: 600;
  color: #5f6c7b;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  -webkit-user-select: none;
          user-select: none;
}

.modern-tab:hover {
  background: rgba(33, 150, 243, 0.08);
}

.modern-tab.active {
  background: linear-gradient(135deg, #83c4fa, #1e88e5);
  color: #fff;
  box-shadow: 0 6px 14px rgba(33, 150, 243, 0.35);
}

.tableEventName:hover {
  color: var(--purple);
  text-decoration: underline;
  /* font-weight: 900; */
}

/* Base table */
.customTableWithoutBg {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}

/* Scroll only tbody */
.customTableWithoutBg tbody {
  display: block;
  max-height: 480px;
  overflow-y: auto;
}

/* Keep header fixed with gradient */
.customTableWithoutBg thead {
  display: table;
  width: 100%;
  table-layout: fixed;
  background: linear-gradient(135deg, rgb(118 182 226), rgb(193 170 254));
  color: #000;
  position: sticky;
  top: 0;
  z-index: 2;
}

/* Keep rows aligned */
.customTableWithoutBg tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

/* Remove individual th background */
.customTableWithoutBg thead th {
  background: transparent;
  color: #000;
}

/* Padding */
.customTableWithoutBg th,
.customTableWithoutBg td {
  padding: 10px;
  text-align: left;
}

/* Scrollbar Styling */
.customTableWithoutBg tbody::-webkit-scrollbar {
  width: 6px;
}

.customTableWithoutBg tbody::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 4px;
}

.trendsDiv {
  max-height: 591px;
  height: 100%;
  overflow: auto;
}

.dashboard-tabs {
  display: flex;
  background: #f1f3f5;
  border-radius: 12px;
  padding: 6px;
  width: fit-content;
  gap: 5px;
}

.tab-item {
  padding: 8px 20px;
  border-radius: 10px;
  font-weight: 500;
  cursor: pointer;
  color: #6c757d;
  transition: all 0.3s ease;
}

.tab-item:hover {
  background: rgba(0, 0, 0, 0.05);
}

.tab-item.active {
  background: linear-gradient(135deg, #76b6e2, #c1aafe);
  color: #fff;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}

.previewInvoice {
  height: 100%;
  max-height: calc(100vh - 130px);
  overflow: auto;
}

.Exammodeldiv {
  background-color: var(--white);
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  box-shadow: 0 0 6px var(--boxshadow);
  padding: 60px;
  /* min-width: 550px; */
  max-height: calc(100vh - 100px);
  overflow: auto;
  max-width: calc(100vw - 32px);
  width: 880px;
}

@media screen and (max-width: 576px) {
  .Exammodeldiv {
    padding: 24px 16px;
  }
}

.dropdown-search-menu {
  position: absolute;
  width: 100%;
  max-width: 100%;
  z-index: 9999;
  max-height: 260px;
  min-height: 40px;
  /* overflow: hidden; */
}

.search-options-list {
  max-height: 200px;
  overflow-y: auto;
}

.search-option-item {
  padding: 10px 14px;
  cursor: pointer;
  transition: 0.2s;
  /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; */
}

.search-option-item:hover {
  background: #f1f5f9;
}

.text40 {
  font-size: 2.857em;
}

.text42 {
  font-size: 3em;
}

.text44 {
  font-size: 3.143em;
}

.font12 {
  font-size: 12px !important;
}

.font11 {
  font-size: 11px !important;
}

.font13 {
  font-size: 13px !important;
}

.font14 {
  font-size: 14px !important;
}

.font16 {
  font-size: 16px !important;
}

.font18 {
  font-size: 18px !important;
}

.font10 {
  font-size: 10px !important;
}

.font20 {
  font-size: 20px !important;
}

.font24 {
  font-size: 1.8em;
}

.gradient-header-soft {
  background: linear-gradient(135deg,
      rgba(118, 182, 226, 0.44),
      rgba(193, 170, 254, 0.7));
  border-radius: 10px 10px 0 0;
}

.light-label-sec {
  color: #9ca3af;
  font-size: 13px;
  font-weight: 500;
}

/* ── Phone ── */
.phone-shell {
  width: 210px;
  min-height: 400px;
  background: #1a1a2e;
  border-radius: 36px;
  padding: 10px;
  /* box-shadow:
    0 0 0 2px #444,
    0 12px 40px rgba(0, 0, 0, 0.45),
    inset 0 0 0 1px #333; */
  display: flex;
  flex-direction: column;
  position: relative;
  flex-shrink: 0;
}

.phone-notch {
  width: 70px;
  height: 20px;
  background: #1a1a2e;
  border-radius: 0 0 14px 14px;
  margin: 0 auto 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.notch-camera {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #2a2a3e;
  border: 1px solid #555;
}

.notch-speaker {
  width: 28px;
  height: 4px;
  border-radius: 4px;
  background: #2a2a3e;
  border: 1px solid #555;
}

.phone-screen {
  flex: 1 1;
  background: #f3f4f6;
  border-radius: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.status-bar {
  background: #1a56db;
  padding: 5px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.status-time {
  color: #fff;
  font-size: 9px;
  font-weight: 700;
}

.signal-bar {
  display: flex;
  gap: 1px;
  align-items: flex-end;
}

.signal-bar div {
  width: 3px;
  border-radius: 1px;
  background: #fff;
}

.battery-wrap {
  width: 16px;
  height: 8px;
  border: 1.5px solid #fff;
  border-radius: 2px;
  position: relative;
  margin-left: 3px;
}

.battery-fill {
  width: 65%;
  height: 100%;
  background: #4ade80;
  border-radius: 1px;
}

.battery-tip {
  position: absolute;
  right: -4px;
  top: 50%;
  transform: translateY(-50%);
  width: 2px;
  height: 4px;
  background: #fff;
  border-radius: 1px;
}

/* Notification card */
.notif-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin: 10px 8px 0;
}

.notif-header {
  background: #1a56db;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.notif-app-icon {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
}

.notif-app-name {
  color: #fff;
  font-size: 9px;
  font-weight: 700;
}

.notif-img-placeholder {
  width: 100%;
  height: 46px;
  background: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  opacity: 0.4;
}

.notif-img {
  width: 100%;
  aspect-ratio: 16/5;
  object-fit: cover;
  display: block;
}

.notif-body {
  padding: 8px 10px 10px;
}

.notif-title {
  font-size: 11px;
  font-weight: 800;
  color: #111827;
  margin-bottom: 3px;
  line-height: 1.3;
  word-break: break-word;
}

.notif-desc {
  font-size: 10px;
  color: #6b7280;
  line-height: 1.4;
  word-break: break-word;
  max-height: 56px;
  overflow: hidden;
}

/* Home icons */
.home-icons {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  padding: 14px 8px 0;
  opacity: 0.2;
}

.home-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #9ca3af;
  margin: 0 auto;
}

.home-indicator {
  padding: 8px 0 10px;
  display: flex;
  justify-content: center;
}

.home-indicator div {
  width: 50px;
  height: 4px;
  background: #9ca3af;
  border-radius: 4px;
}

/* Side buttons */
.btn-vol-up,
.btn-vol-dn,
.btn-power {
  position: absolute;
  width: 4px;
  background: #555;
  border-radius: 2px;
}

.btn-vol-up {
  left: -3px;
  top: 80px;
  height: 22px;
  border-radius: 2px 0 0 2px;
}

.btn-vol-dn {
  left: -3px;
  top: 110px;
  height: 22px;
  border-radius: 2px 0 0 2px;
}

.btn-power {
  right: -3px;
  top: 96px;
  height: 34px;
  border-radius: 0 2px 2px 0;
}

/* Image upload area */
.img-upload-area {
  border: 2px dashed #d1d9f0;
  border-radius: 10px;
  padding: 16px;
  text-align: center;
  cursor: pointer;
  transition:
    border-color 0.15s,
    background 0.15s;
  background: #f9faff;
}

.img-upload-area:hover {
  border-color: #1a56db;
  background: #ebf2ff;
}

.img-upload-area input {
  display: none;
}

.img-preview {
  width: 100%;
  max-height: 100px;
  object-fit: cover;
  border-radius: 8px;
  margin-top: 8px;
}

.delete-drop-btn {
  height: 33px;
  width: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f09595;
  border-radius: 6px;
  background: #fcebeb;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.delete-drop-btn:hover {
  background: #f8d7da;
  border-color: #e35d5d;
  transform: scale(1.05);
}

.delete-drop-btn:active {
  transform: scale(0.95);
}

/* *****************qustion Extractor Table********************* */
.questionTable tr:nth-child(even) {
  background: transparent;
}

.questionTable tr:nth-child(odd) {
  background: transparent;
}

.questionTable td,
.questionTable th {
  padding: 12px 5px;
  border-width: 1px !important;
  border-style: solid !important;
}

.questionTable th {
  /* background-color: var(--purple); */
  color: var(--white);
}

.questionTable {
  border: 1px solid #fff;
  /* font-size: 12px;   */
}

.fc-page-bg {
  background: linear-gradient(180deg, #f4f6fb 0%, #eef0f7 100%);
  /* height: 100vh; */
}


.fc-card {
  background: #ffffff;
  border: 1px solid #e6e9f0;
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 41, 0.03), 0 12px 32px -16px rgba(15, 23, 41, 0.12);
  padding: 12px 14px;
  margin-bottom: 10px;
}


.fc-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  /* margin-bottom: 20px; */
  padding-bottom: 10px;
  border-bottom: 1px solid #e6e9f0;
}

.fc-card-title {
  font-size: 16px;
  font-weight: 700;
  color: #131a2c;
  margin: 0 0 4px;
}

.fc-card-subtitle {
  font-size: 11.5px;
  color: #8d94a3;
  margin: 0;
}

.fc-card-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
  padding-top: 16px;
  border-top: 1px solid #e6e9f0;
}

.fc-card-compact {
  padding: 14px 18px;
  border-radius: 12px;
}

.mobile-menu-btn {
  display: none;
  border: none;
  background: transparent;
  padding: 4px;
  /* margin-right: 15px; */
  align-items: center;
  justify-content: center;
  border: 1px solid #e6e9f0;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
}


.menu-icon {
  font-size: 26px !important;
  color: var(--purple);
}


/* .Title {
  display: flex;
  align-items: center;
  gap: 10px;
} */


@media (max-width: 576px) {
  .fc-card {
    padding: 18px 16px;
    border-radius: 12px;
  }

  .fc-card-header {
    flex-direction: column;
  }
}


@media screen and (max-width: 1550px) {
  .detailsdiv {
    height: calc(100vh - 75px);
    overflow: auto;
  }
}

/* for Publication orders Printing purpose */
@media print {
  body {
    margin: 0;
  }

  .no-print {
    display: none !important;
  }

  .sidebar {
    display: none !important;
  }

  .dashboard {
    width: fit-content;
  }

  .page-break {
    page-break-after: always;
  }

  table {
    page-break-inside: avoid;
  }
}

/* ================= Login Responsive ================= */

@media screen and (max-width: 1400px) {
  .loginContainer {
    width: 450px;
    margin-right: 40px;
  }

  .loginContainer form {
    padding: 40px !important;
  }

  .logoDiv {
    width: 80px;
    height: 80px;
    right: 25px;
    top: -35px;
  }

  .loginlogo {
    width: 60px;
  }
}


@media screen and (max-width: 1024px) {
  .border-default span {
    display: none;
  }

  .label-wrap>* {
    width: 100%;
  }

  *:has(> .label-wrap) {
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;
  }

  *:has(> .label-wrap)>* {
    width: 100%;
  }
}

@media screen and (max-width: 992px) {
  .loginBg {
    justify-content: center;
    align-items: center;
    background-size: cover;
    min-height: 100vh;
  }

  .loginContainer {
    width: 420px;
    margin: 50px auto;
  }

  .loginContainer form {
    padding: 35px !important;
  }

  .loginContainer h3 {
    font-size: 24px;
    margin-bottom: 35px !important;
  }

  .loginContainer label input {
    padding: 13px 15px;
    font-size: 15px;
  }

  .loginContainer label input+span {
    font-size: 1em;
  }

  .otpBox {
    justify-content: center;
  }

  .label {
    width: 140px;
    font-size: 14px;
  }
}

.sidebar-close-btn {
  display: none;
}

.sidebar-close-btn button {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}

.sidebar-close-btn button:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

@media screen and (max-width: 768px) {
  .Title {
    padding-left: 52px !important;
    font-size: 12px !important;
  }

  .inputField {
    width: 100% !important;
    margin: 8px 0;
    max-width: 100%;
  }

  .label-wrap {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .label-wrap>* {
    width: 100%;
  }

  *:has(> .label-wrap) {
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;
  }

  *:has(> .label-wrap)>* {
    width: 100%;
  }

  /* .label {
    width: 100%;
    font-size: 13px;
    margin-bottom: 4px;
    white-space: normal;
    word-break: break-word;
  } */
  .loginBg {
    overflow-y: auto;
    align-items: flex-start;
  }

  .loginBg {
    padding: 20px;
    background-position: center;
  }

  .loginContainer {
    width: 100%;
    max-width: 380px;
    margin: 40px auto;
    border-radius: 15px;
  }

  .loginContainer form {
    padding: 30px !important;
  }

  .logoDiv {
    width: 75px;
    height: 75px;
    right: 20px;
    top: -35px;
  }

  .loginlogo {
    width: 55px;
  }

  .loginContainer h3 {
    font-size: 21px;
    text-align: center;
  }

  .loginContainer label input {
    height: 45px;
    padding-left: 15px;
  }

  .viewPassword {
    top: 4px;
  }

  .btn-primary {
    width: 100%;
  }

  .otpBox {
    width: 100%;
    overflow-x: auto;
  }

  .otpBox input {
    width: 45px !important;
    height: 45px;
  }

  .px-5 {
    padding-left: 25px !important;
    padding-right: 25px !important;
  }

  .mobile-menu-btn {
    display: flex;
    border: none;
    background: none;
  }

  .mobile-menu-btn {
    display: flex;
    width: 40px;
    height: 40px;
  }



  .sidebar {
    position: fixed !important;
    top: 0;
    left: -280px !important;
    width: 250px;
    height: 100vh;
    margin: 0;
    z-index: 9999;
    transition: 0.3s ease;
  }

  .sidebar.sidebar-open {
    left: 0 !important;
  }

  .sidebar-overlay {
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
    z-index: 99;
  }


  .sidebar-overlay.show {
    display: block;
  }

  .dashboard {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .sidebar-close-btn {
    display: flex;
    justify-content: flex-end;
    padding: 10px;
  }
}


@media screen and (max-width: 480px) {
  .Title {
    font-size: 10px !important;
  }

  .Title span {
    display: block;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .label {
    font-size: 12px;
  }

  .loginBg {
    padding: 15px;
  }

  .loginContainer {
    max-width: 100%;
    margin: auto;
  }

  .loginContainer form {
    padding: 25px !important;
  }

  .logoDiv {
    width: 65px;
    height: 65px;
    right: 15px;
    top: -30px;
    padding: 7px;
  }

  .loginlogo {
    width: 50px;
  }

  .loginContainer h3 {
    font-size: 19px;
    margin-bottom: 25px !important;
  }

  .loginContainer label input {
    border-radius: 8px;
    font-size: 14px;
  }

  .loginContainer label input+span {
    left: 16px;
    font-size: 14px;
  }

  .otpBox input {
    width: 38px !important;
    height: 38px;
  }

  .otpBox span {
    margin-left: 8px !important;
  }

  .loginContainer p {
    font-size: 14px;
    text-align: center;
  }
}


@media screen and (max-height: 700px) {}
/* BatchNames (Screen/Common/transactionCommon.js): long batch names scroll inside the
   table cell instead of being cut with "…". Max width = the table cell's 320px minus padding. */
.tc-batchNameScroll {
  max-width: 292px;
  overflow: auto;
  white-space: nowrap;
  padding-bottom: 2px; /* room for the scroll bar */
  scrollbar-width: thin;
  scrollbar-color: #c3c8d4 transparent;
}
/* fills its cell instead of the 292px cap; contain keeps a long name from widening the column */
.tc-batchNameFill {
  max-width: none;
  width: 100%;
  contain: inline-size;
}
.tc-batchNameScroll::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.tc-batchNameScroll::-webkit-scrollbar-thumb {
  background: #c3c8d4;
  border-radius: 6px;
}
.tc-batchNameScroll::-webkit-scrollbar-track {
  background: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,oGAAoG;EACpG;;;;oIAIkI;EAClI,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA,wDAAwD;AACxD,wDAAwD;AACxD;EACE,0EAA0E;EAC1E,2EAA6D;EAC7D,0BAA0B;EAC1B,2DAA2D;EAC3D,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B;GACC;EACD,qDAAqD;EACrD,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;KAEK;AACL;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,WAAW;EACX,4BAA4B;EAC5B,UAAU;EACV,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,+BAA+B;EAC/B,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE;GACC;EACD,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB;GACC;EACD,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;EAClC,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,oDAAoD;EACpD,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;EAC5C,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mEAAmE;EACnE,6CAA6C;EAC7C,+CAA+C;EAC/C,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mEAAmE;EACnE,6CAA6C;EAC7C,+CAA+C;EAC/C,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mEAAmE;EACnE,6CAA6C;EAC7C,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,UAAU;EACV,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;GAEG;AACH;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA,qDAAqD;AACrD;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC,iBAAiB;AACjB;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,wDAAwD;AACxD;EACE,aAAa;AACf;;AAEA,0CAA0C;AAC1C;EACE,+BAA+B;EAC/B,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,iEAAiE;AACjE;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA,6DAA6D;AAC7D;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;GAGG;;AAEH;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;EAC1C,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,6DAA6D;AAC7D;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,iDAAiD;AACjD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,oDAAoD;AACpD;EACE,YAAY;AACd;;AAEA,iEAAiE;AACjE;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;;GAOG;AACH;EACE,8BAA8B;EAC9B,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;AACb;;AAEA,kDAAkD;AAClD;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;;GAEG;AACH;EACE,SAAO;EACP,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;GAEG;AACH;;GAEG;AACH;EACE,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,oEAAoE;AACpE;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,4DAA4D;AAC5D;EACE,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA,gDAAgD;AAChD;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,+CAA+C;AACjD;;AAEA,0DAA0D;AAC1D;EACE,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA,iDAAiD;AACjD;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,8CAA8C;EAC9C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,8CAA8C;EAC9C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE,uBAAuB;AACzB;;AAEA,sCAAsC;;AAEtC;EACE,qDAAqD;EACrD,6DAA6D;EAC7D,0DAA0D;EAC1D,yDAAyD;EACzD,wDAAwD;AAC1D;;AAEA;;;;;;;GAOG;AACH;EACE,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,UAAU;EACV,WAAW;AACb;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB;iBACe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,uBAAuB;AACzB;;AAEA,4EAA4E;AAC5E;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,MAAM;AACR;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,YAAY;AACd;;AAEA,6DAA6D;AAC7D;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B;;+BAE6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA,6DAA6D;;AAE7D;EACE,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,aAAa;EACb,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,0BAA0B;EAC1B,cAAc;EACd,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gCAAgC;;EAEhC;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,YAAY;AACd;;AAEA,kEAAkE;;AAElE;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8FAA8F;AAC9F;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA,oCAAoC;;AAEpC;;EAEE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,UAAU;AACZ;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA,sDAAsD;;AAEtD;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;EACP,qCAAqC;EACrC,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,+EAA+E;;AAE/E;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,uEAAuE;EACvE,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA,YAAY;AACZ;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB;;4BAE0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;+BAE6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb;;;2BAGyB;EACzB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;;;EAGE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,UAAU;EACV,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,SAAS;EACT,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf;;oBAEkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kEAAkE;AAClE;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;EACjB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;AACrB;;;AAGA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sFAAsF;EACtF,kBAAkB;EAClB,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,yBAAyB;EACzB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;;AAGA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;;AAGA;;;;GAIG;;;AAGH;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF;;;AAGA;EACE;IACE,0BAA0B;IAC1B,cAAc;EAChB;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,SAAS;EACX;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,yDAAyD;;AAEzD;EACE;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;;;AAGA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA;IACE,WAAW;EACb;;EAEA;;;;;;KAMG;EACH;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,YAAY;EACd;;;;EAIA;IACE,0BAA0B;IAC1B,MAAM;IACN,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,SAAS;IACT,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,0BAA0B;IAC1B,WAAW;EACb;;;EAGA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,aAAa;EACf;AACF;;;AAGA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;;AAGA,uCAAuC;AACvC;gGACgG;AAChG;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB,EAAE,4BAA4B;EACjD,qBAAqB;EACrB,oCAAoC;AACtC;AACA,gGAAgG;AAChG;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB","sourcesContent":["@font-face {\n  font-family: \"FontAwesome\";\n  src: url(\"https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/fonts/fontawesome-webfont.eot?v=4.2.0\");\n  src:\n    url(\"https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/fonts/fontawesome-webfont.eot?#iefix&v=4.2.0\") format(\"embedded-opentype\"),\n    url(\"https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/fonts/fontawesome-webfont.woff?v=4.2.0\") format(\"woff\"),\n    url(\"https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/fonts/fontawesome-webfont.ttf?v=4.2.0\") format(\"truetype\"),\n    url(\"https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/fonts/fontawesome-webfont.svg?v=4.2.0#fontawesomeregular\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.App {\n  /* text-align: center; */\n  /* display: flex; */\n}\n\n.App {\n  width: 100vw;\n  height: 100vh;\n}\n\n.required {\n  color: red;\n}\n\n/*******************Login Page**************************/\n/*******************Login Page**************************/\n.loginBg {\n  /* background-image: linear-gradient(135deg, #efe6ff 10%, #ccb0ff 100%); */\n  background: url(\"Images/loginbg.png\") center center no-repeat;\n  background-size: 100% 100%;\n  /* background: linear-gradient(180deg, #f4f8ff, #fafbff); */\n  width: 100%;\n  height: 100%;\n}\n\n.loginContainer {\n  margin: auto 50px auto auto;\n  /*box-shadow: 1px 1px 3px 0px var(--boxshadow);\n  */\n  box-shadow: 0 0.25rem 2.1rem rgba(133, 131, 218, 0.2);\n  width: 500px;\n  background: #fff;\n  border-radius: 0.6rem;\n  -webkit-border-radius: 0.6rem;\n  -moz-border-radius: 0.6rem;\n  -ms-border-radius: 0.6rem;\n  -o-border-radius: 0.6rem;\n  position: relative;\n}\n\n/* .loginContainer label{\n    display: none;\n  } */\n.inputField {\n  margin: 0px 0px 0px 7px;\n}\n\n.loginContainer label {\n  position: relative;\n  width: 100%;\n}\n\n.loginContainer label input {\n  /* background-color: #333; */\n  color: #353535;\n  width: 100%;\n  padding: 15px 05px 15px 20px;\n  outline: 0;\n  border: 1px solid rgba(105, 105, 105, 0.397);\n  border-radius: 10px;\n}\n\n.loginContainer label input+span {\n  /* color: rgba(255, 255, 255, 0.5); */\n  position: absolute;\n  left: 22px;\n  top: 15px;\n  font-size: 1.2em;\n  cursor: text;\n  transition: 0.3s ease;\n}\n\n.loginContainer label input:placeholder-shown+span {\n  top: 12.5px;\n  font-size: 0.9em;\n}\n\n.loginContainer label input:focus+span,\n.loginContainer label input:valid+span {\n  color: var(--lightblue);\n  top: -15px;\n  font-size: 0.9em;\n  font-weight: 600;\n  background: #fff;\n  padding: 5px;\n}\n\n.viewPassword {\n  top: 6px;\n  right: 6px;\n}\n\n.logoDiv {\n  position: absolute;\n  right: 30px;\n  top: -40px;\n  background: #fff;\n  width: 90px;\n  height: 90px;\n  border-radius: 50%;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  margin: auto;\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  padding: 9px;\n  box-shadow: 0 0.25rem 2.1rem rgba(133, 131, 218, 0.2);\n}\n\n.loginlogo {\n  width: 70px;\n}\n\n.loginheader {\n  background-color: #f5f5f5;\n  border-radius: 20px 20px 0 0;\n  -webkit-border-radius: 20px 20px 0 0;\n  -moz-border-radius: 20px 20px 0 0;\n  -ms-border-radius: 20px 20px 0 0;\n  -o-border-radius: 20px 20px 0 0;\n}\n\n.radio-button-container {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.radio-button {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n}\n\n.radio-button__input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.radio-button__label {\n  display: inline-block;\n  padding-left: 30px;\n  margin-bottom: 10px;\n  position: relative;\n  font-size: 15px;\n  color: #353535;\n  font-weight: 600;\n  cursor: pointer;\n  text-transform: uppercase;\n  transition: all 0.3s ease;\n}\n\n.radio-button__custom {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid #555;\n  transition: all 0.3s ease;\n}\n\n.radio-button__input:checked+.radio-button__label .radio-button__custom {\n  background-color: #4c8bf5;\n  border-color: transparent;\n  transform: scale(0.8);\n  box-shadow: 0 0 20px #4c8bf580;\n}\n\n.radio-button__input:checked+.radio-button__label {\n  color: #4c8bf5;\n}\n\n.radio-button__label:hover .radio-button__custom {\n  transform: scale(1.2);\n  border-color: #4c8bf5;\n  box-shadow: 0 0 20px #4c8bf580;\n}\n\n/*****************************************************/\n.AppBox {\n  width: 100%;\n  display: flex;\n  background: #f1f1f1;\n}\n\nheader.hide {\n  display: none;\n}\n\nheader {\n  height: 50px;\n  padding: 10px;\n  color: #fff;\n  background-color: var(--purple);\n  display: flex;\n  border-radius: 5px 5px 0 0;\n}\n\n.dashboard {\n  /*display: flex;\n  */\n  width: calc(100vw - 300px);\n  background: #fff;\n  margin: 10px;\n  border-radius: 5px;\n  /*height: 100%;\n  */\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n}\n\n.userInfo {\n  height: 50px;\n  padding: 10px;\n  color: #fff;\n  background-color: var(--purple);\n  border-radius: 5px 5px 0 0;\n  -webkit-border-radius: 5px 5px 0 0;\n  -moz-border-radius: 5px 5px 0 0;\n  -ms-border-radius: 5px 5px 0 0;\n  -o-border-radius: 5px 5px 0 0;\n}\n\n.userInfo span {\n  border: 1px solid;\n  border-radius: 100%;\n  padding: 5px;\n}\n\n.overview {\n  padding: 10px;\n  color: #9e9e9e;\n}\n\n.sidebar {\n  width: 250px;\n  /* height: calc(100vh - 50px); */\n  box-shadow: 0.4px 0.6px 2.8px 0.2px var(--boxshadow);\n  /* overflow: auto; */\n  margin: 10px 10px 10px 15px;\n  background: #fff;\n  border-radius: 5px;\n}\n\n.sidebarList {\n  height: calc(100vh - 170px);\n  width: 100%;\n  padding: 0px;\n  list-style-type: none;\n  overflow: auto;\n}\n\n.sideListRow {\n  background: #fff;\n  /* border: 1px solid var(--transgray); */\n  border-top: 0px;\n  width: 100%;\n  height: auto;\n  padding: 10px 20px;\n  color: var(--purple);\n}\n\n.accordion-body .sideListRow {\n  padding: 10px 10px 10px 28px;\n  border: 0;\n}\n\n.sideListRow a {\n  text-decoration: none;\n  color: #353535;\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.sideListRow.active {\n  background: var(--lightpurple);\n  color: var(--purple);\n  cursor: default;\n  font-weight: bold;\n}\n\n.sideListRow.active a {\n  color: var(--purple);\n}\n\n.sideListRow:hover {\n  background: var(--lightpurple);\n  cursor: pointer;\n}\n\n.sideListRow:hover a {\n  color: var(--purple);\n  font-weight: bold;\n}\n\n.sidebarList .accordion-button {\n  padding: 11px 20px !important;\n  font-size: 13px !important;\n  border-radius: 0 !important;\n  color: #353535;\n  font-weight: 600;\n}\n\n.sidebarList .subAccordion .accordion-button {\n  padding: 11px 20px 11px 28px !important;\n}\n\n.sidebarList .accordion-button:focus {\n  box-shadow: none !important;\n}\n\n.logout {\n  padding: 10px;\n  font-size: 14px;\n}\n\n.contentBox {\n  /* width: calc(100vw - 250px); */\n  box-shadow: 1px 1px 5px 1px var(--transgray);\n  margin: 10px;\n  overflow: auto;\n}\n\n.Title {\n  position: relative;\n  width: 100%;\n  color: var(--purple);\n  height: 50px;\n  padding: 10px 13px;\n  box-shadow: 1px 1px 5px 1px var(--transgray);\n  margin-bottom: 0;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.label {\n  font-weight: bold;\n  width: 170px;\n  /* margin-right: 30px; */\n}\n\n.bookname_label {\n  top: 333px;\n  left: 713px;\n  width: 340px;\n  height: 40px;\n  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;\n  border: 1px solid var(--unnamed-color-707070);\n  background: #ffffff 0% 0% no-repeat padding-box;\n  border: 1px solid #707070;\n  border-radius: 5px;\n  opacity: 1;\n}\n\n.price_label {\n  top: 333px;\n  left: 1073px;\n  width: 150px;\n  height: 40px;\n  /* UI Properties */\n  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;\n  border: 1px solid var(--unnamed-color-707070);\n  background: #ffffff 0% 0% no-repeat padding-box;\n  border: 1px solid #707070;\n  border-radius: 5px;\n  opacity: 1;\n}\n\n.inputField {\n  width: 400px !important;\n  margin: 10px;\n}\n\n.inputEmploy {\n  width: auto !important;\n}\n\n.bookStock {\n  width: 20px !important;\n}\n\n.stockTable th {\n  background-color: var(--purple) !important;\n  color: var(--white);\n  border-style: solid !important;\n}\n\n.stockTable td {\n  background-color: #e8eaf5;\n  border-style: solid !important;\n}\n\n.stockTable::-webkit-scrollbar {\n  width: 0.8em;\n  height: 0.3em;\n  display: block;\n}\n\n.checkbox_container {\n  top: 174px;\n  left: 623px;\n  width: 300px;\n  height: 858px;\n  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;\n  border: 1px solid var(--unnamed-color-707070);\n  border: 1px solid #707070;\n  border-radius: 5px;\n  opacity: 1;\n}\n\n.dropdown_container {\n  border: 1px solid var(--border);\n  opacity: 1;\n  width: 100%;\n  padding: 15px;\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n}\n\n/* .dropdown_container label{\n  display: none;\n} */\n.dropdown_container .custom-Dropdown {\n  width: 90% !important;\n}\n\n.formDiv {\n  height: calc(100vh - 90px);\n  overflow: auto;\n  margin-top: 2px;\n}\n\n.parentCourse {\n  display: flex;\n  float: right;\n  border-bottom: 1px solid;\n  width: 400px;\n}\n\n.parent-border-bottom {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 12px;\n  color: black;\n}\n\n.formWidth {\n  width: max-content;\n  padding: 15px;\n  max-width: 100%;\n}\n\n.radiobtn {\n  border-radius: 10px !important;\n  padding: 3px 10px !important;\n  -o-border-radius: 20px !important;\n}\n\n.AssignCheckbox {\n  flex: 1;\n  background-color: #fff;\n  border: 1px solid;\n  border: width 1px;\n  padding: 5px;\n  justify-content: center;\n  align-items: center;\n  margin: 12px;\n}\n\n.addMorebtn {\n  border-radius: 20px !important;\n  -webkit-border-radius: 20px !important;\n  -moz-border-radius: 20px !important;\n  -ms-border-radius: 20px !important;\n  -o-border-radius: 20px !important;\n}\n\n.submitbtn {\n  border-radius: 20px !important;\n  -webkit-border-radius: 20px !important;\n  -moz-border-radius: 20px !important;\n  -ms-border-radius: 20px !important;\n  -o-border-radius: 20px !important;\n  padding: 7px 20px !important;\n}\n\n.delete {\n  border-radius: 20px !important;\n  -webkit-border-radius: 20px !important;\n  -moz-border-radius: 20px !important;\n  -ms-border-radius: 20px !important;\n  -o-border-radius: 20px !important;\n  padding: 7px 20px !important;\n}\n\n.submitbtn a {\n  color: var(--white);\n  text-decoration: none;\n}\n\n.submitbtn a:hover {\n  color: var(--white);\n  text-decoration: none;\n}\n\n.custom-Dropdown {\n  width: 400px !important;\n}\n\n.browseDiv {\n  width: 400px !important;\n}\n\n.browseDiv .custom-file {\n  width: 100%;\n}\n\n/*********************Header*************************/\n.sidebar-toggle {\n  padding: 2px 15px;\n  text-decoration: none;\n}\n\n.sidebar-toggle:before {\n  font-family: \"FontAwesome\";\n  content: \"\\f0c9\";\n  color: #fff;\n  font-size: 20px;\n}\n\n/* ********display examset********* */\n.activetable {\n  width: 100px;\n}\n\n/********************************************/\n.rightSide {\n  border-left: 1px solid var(--boxshadow);\n  padding: 0px !important;\n}\n\n.rightSideHeading {\n  background-color: var(--purple);\n  color: var(--white);\n  padding: 10px;\n  text-align: center;\n  font-weight: bold;\n}\n\n.teacherexam {\n  background-color: var(--white);\n  color: var(--purple);\n  font-weight: bold;\n}\n\n.dataShow {\n  padding: 0 15px 10px;\n  height: calc(100vh - 185px);\n  overflow: auto;\n  font-size: 18px;\n}\n\n.form-switch {\n  padding: 0 !important;\n}\n\n.form-switch .form-check-input {\n  margin-left: 0 !important;\n}\n\n/*********************Parent Course***************************/\n.parentCoursedata {\n  display: flex;\n  font-size: 20px;\n}\n\n.parentCoursedata span {\n  font-size: 14px;\n  flex: 2;\n  margin-bottom: 10px;\n}\n\n.purple {\n  color: var(--purple);\n}\n\n.red {\n  color: red;\n}\n\n.blue {\n  color: #016fe9;\n}\n\n/**********************************/\n/* Assign Books */\n.Book_Info {\n  width: 98%;\n}\n\n.bookinfo_btn {\n  margin: 5px;\n  padding: 2px 14px !important;\n}\n\n.bookinfo_label1 {\n  flex: 2;\n  margin: 2px;\n}\n\n.bookinfo_label2 {\n  flex: 1;\n  margin: 5px;\n}\n\n.MuiSelect-select {\n  padding: 9px !important;\n  font-size: 14px !important;\n  padding-right: 30px !important;\n}\n\n.bookAssignCustom .custom-Dropdown {\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n}\n\n.checkVal {\n  margin-left: 10px;\n}\n\n/* *************CreateSub Category******************** */\n.SubCategory_radiobtn {\n  padding: 10px;\n}\n\n/**************Add Book*******************/\n.browselabel {\n  background-color: var(--purple);\n  color: white;\n  font-family: sans-serif;\n  border-radius: 0.3rem;\n  cursor: pointer;\n  width: 48px;\n  text-align: center;\n  font-size: 32px;\n  margin: 0 10px;\n}\n\n.removelable label {\n  display: none;\n}\n\n/********************Create Main Category************************/\n.rightSide .custom-Dropdown {\n  width: 100% !important;\n}\n\n.dropdownDiv .d-flex {\n  width: 100%;\n}\n\n/* *****************create coupon code********************* */\ntr:nth-child(even) {\n  background: var(--lightpurple);\n}\n\ntr:nth-child(odd) {\n  background: #fff;\n}\n\ntd,\nth {\n  padding: 12px 5px;\n  border-width: 1px !important;\n  border-style: none !important;\n}\n\nth {\n  background-color: var(--purple);\n  color: var(--white);\n}\n\ntable {\n  border: 1px solid var(--transgray);\n  /* font-size: 12px;   */\n}\n\n.customTableWithoutBg tr {\n  background: transparent !important;\n}\n\n/* .r1{\n  border: 1px solid red;\n  color: #000;\n} */\n\n.t.r1 {\n  border: 2px solid black;\n}\n\n.performanceTable th {\n  /* background-color: #e6e3e3; */\n  background-color: var(--purple) !important;\n  color: var(--white);\n  border-style: solid !important;\n}\n\n.performanceTable td {\n  background-color: #e8eaf5;\n  border-style: solid !important;\n}\n\n.issue th {\n  background-color: var(--red);\n  color: var(--white);\n}\n\n.customSelect {\n  width: 100%;\n}\n\n.font-10 {\n  font-size: 10px !important;\n}\n\n.font {\n  font-size: xx-small !important;\n}\n\n/* ********************Create Exam Set********************* */\n.examSet-dashboard {\n  display: flex;\n}\n\n.examSetRadio {\n  display: flex;\n}\n\n/* *************display exam set*************** */\n.leftSideExam {\n  padding: 0px !important;\n  height: max-content;\n  margin-left: 30px;\n}\n\n.rightSideExam {\n  padding: 0px !important;\n  height: max-content;\n  margin-left: 50px;\n}\n\n/* ****************Copy Exam Set****************** */\n.examdropdown {\n  width: 500px;\n}\n\n/* *********************Add Question Yes*********************** */\n.question-label {\n  font-weight: bold;\n}\n\n.question-border {\n  border: 1px solid;\n  display: flex;\n  justify-content: space-between;\n  margin-left: 20px;\n  border-color: #707070;\n}\n\n.question-title {\n  font-weight: bolder;\n}\n\n.section-subtitle {\n  background-color: var(--purple);\n  text-align: center;\n  width: 150px;\n  color: var(--white);\n  -webkit-margin-start: 20px;\n}\n\n.sectionleft {\n  margin-left: 78px;\n}\n\n/* .blackQuestion{\n  height: 50px;\n  padding: 10px 27px;\n  font-weight: bold;\n \n  padding: 10px;\n\n} */\n.correctOption-check {\n  background-color: var(--white);\n  width: 150px;\n  text-decoration: var(--purple) !important;\n}\n\n.subjectD {\n  width: 200px;\n  padding: 6px;\n  margin-left: 50px !important;\n}\n\n.add_Question-btn {\n  border-radius: 20px !important;\n  -webkit-border-radius: 20px !important;\n  -moz-border-radius: 20px !important;\n  -ms-border-radius: 20px !important;\n  -o-border-radius: 20px !important;\n}\n\n.add_Question-btn a {\n  color: var(--blue);\n  text-decoration: none;\n}\n\n.add_Question-btn a:hover {\n  color: var(--white);\n  text-decoration: none;\n}\n\n.quesdesctype {\n  position: absolute;\n  right: 10px;\n  top: 39px;\n  background: #fff;\n  color: #9e9e9e;\n  z-index: 10;\n  padding: 6px 9px;\n  font-size: 12px;\n  box-shadow: 1px 2px 5px 1px var(--transgray);\n}\n\n.addInputbtn {\n  background: transparent;\n  border: 1px solid #fff;\n  color: #fff;\n}\n\n/* ***************Create Section**************** */\n.testInput {\n  width: 300px !important;\n  margin: 10px;\n}\n\n/* .editor_content{\n  height:fit-content;\n} */\n.sectioncontainer {\n  flex: 1;\n  background-color: #fff;\n  border: 1px solid;\n  border: width 1px;\n  padding: 10px;\n  justify-content: center;\n  align-items: center;\n  margin: 12px;\n  margin-top: 5px !important;\n  height: auto;\n}\n\n.sectioncontainerSubContainer {\n  flex: 1;\n  background-color: #fff;\n  border: 1px solid;\n  border: width 1px;\n  width: fit-content;\n  padding: 10px;\n  justify-content: center;\n  align-items: center;\n  margin: 20px;\n  padding: 10px;\n  margin-top: 5px !important;\n  height: auto;\n}\n\n.section-btn {\n  border-radius: 20px !important;\n  -webkit-border-radius: 20px !important;\n  -moz-border-radius: 20px !important;\n  -ms-border-radius: 20px !important;\n  -o-border-radius: 20px !important;\n}\n\n.section-btn a {\n  color: var(--blue);\n  text-decoration: none;\n}\n\n.section-btn a:hover {\n  color: var(--white);\n  text-decoration: none;\n}\n\n.sectionFormDiv {\n  height: calc(100vh - 122px);\n  overflow: auto;\n}\n\n.sectionFormWidth {\n  width: 100%;\n  padding: 15px;\n}\n\n.sectionSubTitles {\n  font-weight: bold !important;\n}\n\n.CreateQuestionTitle {\n  position: relative;\n  width: 100%;\n  color: var(--purple);\n  height: 50px;\n  padding: 10px 27px;\n  font-weight: bold;\n  background-color: var(--purple);\n  color: var(--white);\n  padding: 10px;\n  margin-top: 15px;\n}\n\n.NewOpt {\n  background-color: #353535;\n  color: #ffffff;\n}\n\n/* .sectionTotal{\n  width:60%;\n} */\n/* .mycasa-grand{\n  width:200px;\n} */\n.section-second {\n  width: 100px;\n  display: flex;\n  justify-content: space-around;\n  padding: 4px;\n}\n\n.mycasa {\n  font-weight: bold;\n}\n\n.mycasa-input {\n  margin-left: 1rem;\n  padding: 4px;\n}\n\n/* ***************Create package Category************************* */\n.session_flag {\n  border: 1px solid var(--border);\n  padding: 5px;\n}\n\n.datepicker {\n  margin: 5px 0;\n}\n\n.datepicker fieldset {\n  display: none !important;\n}\n\n.datepicker .MuiFormControl-root {\n  border: 1px solid var(--border);\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n}\n\n.datepicker input {\n  padding: 5px 14px;\n  font-size: 14px;\n}\n\n/* ******************Admit Card Creation****************** */\n.admitcardcontainer {\n  background-color: #fff;\n  border: 1px solid;\n  border: width 1px;\n  padding: 10px;\n}\n\n.admitCardHeading {\n  text-align: left;\n  font-weight: bold;\n}\n\n.admitCardTitle {\n  position: relative;\n  width: 100%;\n  color: var(--purple);\n  height: 50px;\n  padding: 10px 27px;\n  margin-bottom: 0;\n  font-weight: bold;\n  background-color: var(--purple);\n  color: var(--white);\n  padding: 10px;\n}\n\n.addInput {\n  border-radius: 20px !important;\n  display: flex;\n  justify-content: flex-end;\n  -webkit-border-radius: 20px !important;\n  -moz-border-radius: 20px !important;\n  -ms-border-radius: 20px !important;\n  -o-border-radius: 20px !important;\n  text-decoration-color: white;\n}\n\n.admitcardInputMain {\n  display: flex;\n  justify-content: space-between;\n}\n\n.admitcardInput {\n  width: 10px;\n}\n\n/* **************Recorded video*************** */\n.Recorded_video {\n  border: 1px solid;\n  display: flex;\n  justify-content: space-between;\n  margin-left: 200px;\n  border-color: #707070;\n  width: 400px;\n}\n\n.time {\n  border: 1px solid #ced4da;\n  padding: 4px;\n}\n\n.time:focus-visible {\n  color: #212529;\n  background-color: #fff;\n  border-color: #86b7fe;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 25%);\n}\n\n/* ********************ASSIGN TEACHER******************* */\n.TeacherDropdown {\n  width: 200px;\n  padding: 6px;\n  margin-left: 50px !important;\n}\n\n/* **************** I Support****************** */\n.liveSchedule {\n  border-radius: 20px !important;\n  -webkit-border-radius: 20px !important;\n  -moz-border-radius: 20px !important;\n  -ms-border-radius: 20px !important;\n  -o-border-radius: 20px !important;\n}\n\n.CourseSupport {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  justify-content: space-between;\n  min-height: 40px;\n  padding: 4px 27px;\n  background-color: #e8eaf5;\n  box-shadow: 1px 1px 5px 1px var(--lightpurple);\n  margin-top: 20px;\n  font-weight: bold;\n}\n\n@media screen and (max-width: 576px) {\n  .CourseSupport {\n    padding: 4px 12px;\n  }\n}\n\n.paginateno .MuiTablePagination-toolbar {\n  min-height: 40px !important;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.CourseTableSupport {\n  display: flex;\n  justify-content: space-between;\n  height: 50px;\n  padding: 10px 27px;\n  background-color: #3f51b5;\n  box-shadow: 1px 1px 5px 1px var(--lightpurple);\n  margin-top: 30px;\n  font-weight: bold;\n}\n\n.momHeader {\n  height: 50px;\n  padding: 10px;\n  color: #fff;\n  background-color: var(--purple);\n}\n\n.mombg {\n  background: #f7f7fd;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.bookBox {\n  width: 450px;\n}\n\n.bookimg {\n  width: 60px;\n  margin: 7px;\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n}\n\n/******************************************/\n.natoption .MuiSelect-select {\n  padding: 4px !important;\n}\n\n/* /******************************** */\n\n.sidebar .accordion-button:not(.collapsed)::after {\n  transform: rotate(45deg) translate(0px, 0) !important;\n  -webkit-transform: rotate(45deg) translate(0px, 0) !important;\n  -moz-transform: rotate(45deg) translate(0px, 0) !important;\n  -ms-transform: rotate(45deg) translate(0px, 0) !important;\n  -o-transform: rotate(45deg) translate(0px, 0) !important;\n}\n\n/* .accordion-button:after {\n  background-image: none !important;\n  border-top: 5px solid transparent;\n  border-left: 8px solid #9e9e9e;\n  border-bottom: 5px solid transparent;\n  width: 10px !important;\n  height: 10px !important;\n} */\n.sidebar .accordion-button:after {\n  background-image: none !important;\n  border: solid #9e9e9e;\n  border-width: 0 2px 2px 0;\n  display: inline-block;\n  padding: 2px;\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n  -moz-transform: rotate(-45deg);\n  -ms-transform: rotate(-45deg);\n  -o-transform: rotate(-45deg);\n  width: 7px;\n  height: 7px;\n}\n\n/*****************Support***********************/\n.statusbtn {\n  width: max-content;\n  margin: auto;\n}\n\n.btn-div {\n  font-size: 15px;\n  font-weight: lighter;\n  color: #008000;\n  border: 1px solid #008000;\n  border-radius: 20px;\n  padding: 5px;\n  margin-right: 10px;\n  cursor: pointer;\n}\n\n.btn-div:hover {\n  background-color: #008000;\n  color: #ffffff;\n}\n\n.number-div {\n  background-color: #008000;\n  color: #ffffff;\n  font-size: 14px;\n  height: 20px;\n  padding: 2px 5px;\n  border-radius: 50%;\n  position: absolute;\n  right: 3px;\n  top: -10px;\n}\n\n.unreadcount {\n  position: absolute;\n  top: -10px;\n  right: 14px;\n  padding: 2px 5px;\n  /* width: 20px;\n  height: 20px; */\n  border-radius: 50%;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  color: #fff;\n  /* padding-left: 5px; */\n}\n\n/**************************Transction Edutech*******************************/\n.userDetailHeading {\n  background: var(--purple);\n  color: var(--white);\n}\n\n.headlabel {\n  width: 250px;\n  display: inline-block;\n}\n\n.removeButton {\n  position: absolute;\n  right: -44px;\n  top: -15px;\n}\n\n.removeButton2 {\n  position: absolute;\n  right: -12px;\n  top: 0;\n}\n\n.closeBtn {\n  position: absolute;\n  right: 93px;\n  top: 0;\n}\n\n.closePressMediaBtn {\n  position: absolute;\n  right: 314px;\n  top: 0;\n}\n\n.closeIfasEventBtn {\n  position: absolute;\n  right: 341px;\n  top: 0;\n}\n\n/************************Custom Checkbox****************************/\n.roundedCheckBox {\n  display: flex;\n  position: relative;\n  padding-left: 20px;\n  /* margin-bottom: 12px; */\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n/* Hide the browser's default checkbox */\n.roundedCheckBox input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n/* Create a custom checkbox */\n.checkmark {\n  position: absolute;\n  top: 3px;\n  left: 0;\n  height: 14px;\n  width: 14px;\n  border-radius: 50%;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  /* background-color: #ccc; */\n  border: 1px solid #707070;\n}\n\n/* On mouse-over, add a grey background color */\n.roundedCheckBox:hover input~.checkmark {\n  background-color: #ccc;\n}\n\n/* When the checkbox is checked, add a blue background */\n.roundedCheckBox input:checked~.checkmark {\n  /* background-color: #2196f3; */\n  background-color: #0d6efd;\n  border: none;\n}\n\n/* Create the checkmark/indicator (hidden when not checked) */\n.checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n/* Show the checkmark when checked */\n.roundedCheckBox input:checked~.checkmark:after {\n  display: block;\n}\n\n/* Style the checkmark/indicator */\n.roundedCheckBox .checkmark:after {\n  left: 2px;\n  top: 2px;\n  width: 10px;\n  height: 10px;\n  border: solid white;\n  border-radius: 50%;\n  border-width: 3px 3px 3px 3px;\n  /* -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transform: rotate(45deg); */\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n}\n\n/***********************OnlineTestSeries*****************************/\n.questionimg {\n  aspect-ratio: 16/9;\n  width: 70px;\n}\n\n.changePasswordBtn {\n  margin-top: 11px;\n  width: 174px;\n  height: 36px;\n  margin-left: 93px;\n}\n\n/* ***************stock Management************************* */\n\n.dateStyle {\n  margin-left: 90px;\n}\n\n/**************Drag n Drop***************/\n.dragndropContainer {\n  height: 90vh;\n  width: 80vw;\n  margin: 0 auto;\n  padding: 10px;\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.small-box {\n  width: 48%;\n  box-shadow: 1px 2px 5px 0px gray;\n  height: calc(100vh - 10vh);\n  overflow: auto;\n  padding: 10px;\n}\n\n.task {\n  border: 1px solid white;\n  margin: 10px;\n  box-shadow: 1px 1px 4px gray;\n  /* height: 8vh; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n}\n\n.dragged {\n  background-color: rgba(200, 200, 200, 0.3);\n  opacity: 0.5;\n  cursor: pointer;\n}\n\n.dragged-over {\n  background: rgba(255, 0, 0, 0.2);\n\n  .task {\n    background: rgba(255, 0, 0, 0.1);\n  }\n}\n\n.orderHistoryPopupimg {\n  width: 100%;\n  max-width: 500px;\n}\n\n.SubContainer {\n  width: max-content;\n}\n\n.add-more-Box {\n  border: solid 1px #000;\n  border-radius: 0;\n}\n\n.uvName {\n  width: 120px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.chart-Box {\n  box-shadow: 0 0px 7px -3px #b5b5b5;\n  padding: 30px;\n  margin: 25px;\n}\n\n/***********************CXO Dashboard*****************************/\n\n.cardBox {\n  flex: 1 1 209px;\n  font-size: 1.2em;\n  border: 1px solid var(--blue);\n  padding: 15px 12px;\n  margin: 10px;\n  background: #fff;\n  flex-direction: column;\n  align-items: center;\n  max-width: 210px;\n}\n\n.cardBox.active {\n  border-color: #016fe9 !important;\n}\n\n.count {\n  color: var(--blue);\n}\n\n/************************** CRM completeLeadDetail Page***************************************/\n.leaddetails {\n  height: calc(100vh - 60px);\n  overflow: hidden;\n}\n\n.leaddetails input {\n  font-size: 12px !important;\n}\n\n.leaddetails .CustomDropDown .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {\n  line-height: 2em !important;\n}\n\n.leaddetails .CustomDropDown .MuiSelect-select {\n  font-size: 12px !important;\n}\n\n.boxshadow {\n  box-shadow: 0px 2px 10px 2px #0000000d;\n}\n\n.detailsdiv {\n  height: calc(100vh - 90px);\n  overflow: auto;\n}\n\n.inventoryImport img {\n  width: 27px !important;\n  height: 26px !important;\n  margin-bottom: -7px;\n}\n\n.tabheader {\n  background-color: var(--purple);\n  color: var(--white);\n}\n\n.input-border {\n  height: 50vh;\n  overflow-y: auto;\n}\n\n/*******Support Number**************/\n#inputGroupSelect01 {\n  width: 50px;\n  /* Adjust the width as needed */\n}\n\n.form-select {\n  width: 10px;\n}\n\n/* ************New CSS************ */\n\n.contentScrollbar::-webkit-scrollbar,\n.contentScrollbar .ReactVirtualized__Grid::-webkit-scrollbar {\n  display: block;\n  width: 0.3em;\n}\n\n.react-datepicker {\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.react-datepicker__header {\n  background-color: #4a90e2;\n  color: #fff;\n}\n\n.react-datepicker__current-month,\n.react-datepicker__year {\n  font-weight: bold;\n}\n\n.react-datepicker__navigation--previous,\n.react-datepicker__navigation--next {\n  border: 7px solid transparent;\n}\n\n.react-datepicker__navigation--previous {\n  border-right-color: #fff;\n  margin-left: 10px;\n}\n\n.react-datepicker__navigation--next {\n  border-left-color: #fff;\n  margin-right: 10px;\n}\n\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--keyboard-selected {\n  background-color: #4a90e2;\n  color: #fff;\n}\n\n.react-datepicker__year-text:hover {\n  background-color: #4a90e2;\n}\n\n/* Style the placeholder text */\n.year-picker::placeholder {\n  color: #aaa;\n  font-style: italic;\n}\n\n/* Custom styles for the year picker input */\n.year-picker {\n  width: 200px;\n  padding: 7px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 16px;\n  color: #333;\n}\n\n.otpBox input {\n  width: 60px !important;\n  height: 60px !important;\n  border-radius: 5px;\n  border: 2px solid #ced4da;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n}\n\n.otpBox input:focus-visible {\n  outline: 0px;\n  border-color: #86b7fe;\n  color: var(--blue);\n  font-weight: bolder;\n  box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 25%);\n}\n\n.bagdeColor {\n  background: #ff3b30;\n}\n\n.totalOrderDiv {\n  background: #fdfbdf;\n}\n\n.divtext {\n  color: #ff3b30;\n}\n\n.totalLeadDiv {\n  background: #ffeaea;\n}\n\n.phdDiv {\n  background: #efffe1;\n}\n\n.mscDiv {\n  background: #e4fdff;\n}\n\n.ugcDiv {\n  background: #feeaff;\n}\n\n/* Canvas Js Link removed */\n.canvasjs-chart-credit {\n  display: none;\n}\n\n.ugcDiv {\n  background: #feeaff;\n}\n\n/* /////////////////////////// */\n.coustomlable {\n  width: 0px;\n}\n\n/* ******************INFLUENCER DASHBOARD*************** */\n.levelsize {\n  width: 100%;\n  max-width: 270px;\n}\n\n.levelbg {\n  background-color: #f7bded14;\n  border-radius: 10px;\n  position: relative;\n}\n\n.currentbenefitbg {\n  background-color: #abc6e721;\n  border-radius: 10px;\n  height: 100%;\n  max-height: 300px;\n  padding: 20px;\n}\n\n.futurebenefitbg {\n  background-color: #b3fdbe24;\n  border-radius: 10px;\n  height: 100%;\n  max-height: 300px;\n  padding: 20px;\n}\n\n.couponplace {\n  position: absolute;\n  right: 0px;\n}\n\n.performcard {\n  background-color: white;\n  border-radius: 5px;\n  height: 100%;\n  max-height: 150px;\n  width: 100%;\n  max-width: 250px;\n}\n\n/* ******************RATING Component*************** */\n\n.bronze {\n  background-color: #cd7f32;\n}\n\n.silver {\n  background-color: #c0c0c0;\n}\n\n.gold {\n  background-color: #ffd700;\n}\n\n.platinum {\n  background-color: #969696;\n}\n\n.left-section {\n  flex: 2;\n}\n\n.right-section {\n  flex: 1;\n  /* Takes 1/3 of the available space */\n  border: 1px solid #ccc;\n  padding: 15px;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n  overflow-y: auto;\n  /* Adds scroll for overflow */\n  max-height: 80vh;\n  /* Adjust the height as needed */\n}\n\n.card-container {\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 10px;\n  background-color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.card-box {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  /* Space between cards */\n}\n\n.orderAnalysisSumCard {\n  border-radius: 15px;\n  box-shadow: 0px 13px 15px 0px #efececab;\n  text-align: center;\n  color: #6c757d;\n}\n\n.pdf-Uploaded {\n  width: 80px;\n  height: 80px;\n  border: 2px dashed #cfd1d2;\n  border-radius: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background-color: #f9f9f9;\n  margin: 15px 0;\n}\n\n.pdf-Uploaded:hover {\n  border-color: #0d47a1;\n  background-color: #e3f2fd;\n}\n\n.pdf-Uploaded img {\n  width: 75px;\n  height: 75px;\n  object-fit: contain;\n}\n\n.pdf-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  max-width: 250px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* *************************SUNDAY TEST ANALYSIS CSS************************* */\n\n.sundayAnalysisProgressCircle {\n  width: 100%;\n  max-width: 77px;\n}\n\n.progressCircleColor1 .CircularProgressbar-path {\n  stroke: var(--green) !important;\n}\n\n.progressCircleColor2 .CircularProgressbar-path {\n  stroke: var(--red) !important;\n}\n\n.progressCircleColor1 .CircularProgressbar-text,\n.progressCircleColor2 .CircularProgressbar-text {\n  fill: var(--black) !important;\n  font-weight: bold;\n}\n\n.circleBelowText {\n  font-size: 12px;\n  font-weight: bold;\n}\n\n/* *************************Refund Payment CSS************************* */\n.modern-tab-wrapper {\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  background: #dce6ff;\n  border-radius: 30px;\n  padding: 4px;\n  width: fit-content;\n  max-width: 100%;\n  gap: 6px;\n}\n\n.modern-tab {\n  flex-shrink: 0;\n  padding: 8px 24px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #5f6c7b;\n  border-radius: 30px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  user-select: none;\n}\n\n.modern-tab:hover {\n  background: rgba(33, 150, 243, 0.08);\n}\n\n.modern-tab.active {\n  background: linear-gradient(135deg, #83c4fa, #1e88e5);\n  color: #fff;\n  box-shadow: 0 6px 14px rgba(33, 150, 243, 0.35);\n}\n\n.tableEventName:hover {\n  color: var(--purple);\n  text-decoration: underline;\n  /* font-weight: 900; */\n}\n\n/* Base table */\n.customTableWithoutBg {\n  border-collapse: collapse;\n  width: 100%;\n  table-layout: fixed;\n}\n\n/* Scroll only tbody */\n.customTableWithoutBg tbody {\n  display: block;\n  max-height: 480px;\n  overflow-y: auto;\n}\n\n/* Keep header fixed with gradient */\n.customTableWithoutBg thead {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  background: linear-gradient(135deg, rgb(118 182 226), rgb(193 170 254));\n  color: #000;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n/* Keep rows aligned */\n.customTableWithoutBg tbody tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n\n/* Remove individual th background */\n.customTableWithoutBg thead th {\n  background: transparent;\n  color: #000;\n}\n\n/* Padding */\n.customTableWithoutBg th,\n.customTableWithoutBg td {\n  padding: 10px;\n  text-align: left;\n}\n\n/* Scrollbar Styling */\n.customTableWithoutBg tbody::-webkit-scrollbar {\n  width: 6px;\n}\n\n.customTableWithoutBg tbody::-webkit-scrollbar-thumb {\n  background-color: #c1c1c1;\n  border-radius: 4px;\n}\n\n.trendsDiv {\n  max-height: 591px;\n  height: 100%;\n  overflow: auto;\n}\n\n.dashboard-tabs {\n  display: flex;\n  background: #f1f3f5;\n  border-radius: 12px;\n  padding: 6px;\n  width: fit-content;\n  gap: 5px;\n}\n\n.tab-item {\n  padding: 8px 20px;\n  border-radius: 10px;\n  font-weight: 500;\n  cursor: pointer;\n  color: #6c757d;\n  transition: all 0.3s ease;\n}\n\n.tab-item:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.tab-item.active {\n  background: linear-gradient(135deg, #76b6e2, #c1aafe);\n  color: #fff;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);\n}\n\n.previewInvoice {\n  height: 100%;\n  max-height: calc(100vh - 130px);\n  overflow: auto;\n}\n\n.Exammodeldiv {\n  background-color: var(--white);\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n  box-shadow: 0 0 6px var(--boxshadow);\n  padding: 60px;\n  /* min-width: 550px; */\n  max-height: calc(100vh - 100px);\n  overflow: auto;\n  max-width: calc(100vw - 32px);\n  width: 880px;\n}\n\n@media screen and (max-width: 576px) {\n  .Exammodeldiv {\n    padding: 24px 16px;\n  }\n}\n\n.dropdown-search-menu {\n  position: absolute;\n  width: 100%;\n  max-width: 100%;\n  z-index: 9999;\n  max-height: 260px;\n  min-height: 40px;\n  /* overflow: hidden; */\n}\n\n.search-options-list {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.search-option-item {\n  padding: 10px 14px;\n  cursor: pointer;\n  transition: 0.2s;\n  /* white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; */\n}\n\n.search-option-item:hover {\n  background: #f1f5f9;\n}\n\n.text40 {\n  font-size: 2.857em;\n}\n\n.text42 {\n  font-size: 3em;\n}\n\n.text44 {\n  font-size: 3.143em;\n}\n\n.font12 {\n  font-size: 12px !important;\n}\n\n.font11 {\n  font-size: 11px !important;\n}\n\n.font13 {\n  font-size: 13px !important;\n}\n\n.font14 {\n  font-size: 14px !important;\n}\n\n.font16 {\n  font-size: 16px !important;\n}\n\n.font18 {\n  font-size: 18px !important;\n}\n\n.font10 {\n  font-size: 10px !important;\n}\n\n.font20 {\n  font-size: 20px !important;\n}\n\n.font24 {\n  font-size: 1.8em;\n}\n\n.gradient-header-soft {\n  background: linear-gradient(135deg,\n      rgba(118, 182, 226, 0.44),\n      rgba(193, 170, 254, 0.7));\n  border-radius: 10px 10px 0 0;\n}\n\n.light-label-sec {\n  color: #9ca3af;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n/* ── Phone ── */\n.phone-shell {\n  width: 210px;\n  min-height: 400px;\n  background: #1a1a2e;\n  border-radius: 36px;\n  padding: 10px;\n  /* box-shadow:\n    0 0 0 2px #444,\n    0 12px 40px rgba(0, 0, 0, 0.45),\n    inset 0 0 0 1px #333; */\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.phone-notch {\n  width: 70px;\n  height: 20px;\n  background: #1a1a2e;\n  border-radius: 0 0 14px 14px;\n  margin: 0 auto 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.notch-camera {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #2a2a3e;\n  border: 1px solid #555;\n}\n\n.notch-speaker {\n  width: 28px;\n  height: 4px;\n  border-radius: 4px;\n  background: #2a2a3e;\n  border: 1px solid #555;\n}\n\n.phone-screen {\n  flex: 1;\n  background: #f3f4f6;\n  border-radius: 24px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.status-bar {\n  background: #1a56db;\n  padding: 5px 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.status-time {\n  color: #fff;\n  font-size: 9px;\n  font-weight: 700;\n}\n\n.signal-bar {\n  display: flex;\n  gap: 1px;\n  align-items: flex-end;\n}\n\n.signal-bar div {\n  width: 3px;\n  border-radius: 1px;\n  background: #fff;\n}\n\n.battery-wrap {\n  width: 16px;\n  height: 8px;\n  border: 1.5px solid #fff;\n  border-radius: 2px;\n  position: relative;\n  margin-left: 3px;\n}\n\n.battery-fill {\n  width: 65%;\n  height: 100%;\n  background: #4ade80;\n  border-radius: 1px;\n}\n\n.battery-tip {\n  position: absolute;\n  right: -4px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 2px;\n  height: 4px;\n  background: #fff;\n  border-radius: 1px;\n}\n\n/* Notification card */\n.notif-card {\n  background: #fff;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  margin: 10px 8px 0;\n}\n\n.notif-header {\n  background: #1a56db;\n  padding: 5px 10px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.notif-app-icon {\n  width: 14px;\n  height: 14px;\n  border-radius: 3px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 8px;\n}\n\n.notif-app-name {\n  color: #fff;\n  font-size: 9px;\n  font-weight: 700;\n}\n\n.notif-img-placeholder {\n  width: 100%;\n  height: 46px;\n  background: #e5e7eb;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  opacity: 0.4;\n}\n\n.notif-img {\n  width: 100%;\n  aspect-ratio: 16/5;\n  object-fit: cover;\n  display: block;\n}\n\n.notif-body {\n  padding: 8px 10px 10px;\n}\n\n.notif-title {\n  font-size: 11px;\n  font-weight: 800;\n  color: #111827;\n  margin-bottom: 3px;\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n.notif-desc {\n  font-size: 10px;\n  color: #6b7280;\n  line-height: 1.4;\n  word-break: break-word;\n  max-height: 56px;\n  overflow: hidden;\n}\n\n/* Home icons */\n.home-icons {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  padding: 14px 8px 0;\n  opacity: 0.2;\n}\n\n.home-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: #9ca3af;\n  margin: 0 auto;\n}\n\n.home-indicator {\n  padding: 8px 0 10px;\n  display: flex;\n  justify-content: center;\n}\n\n.home-indicator div {\n  width: 50px;\n  height: 4px;\n  background: #9ca3af;\n  border-radius: 4px;\n}\n\n/* Side buttons */\n.btn-vol-up,\n.btn-vol-dn,\n.btn-power {\n  position: absolute;\n  width: 4px;\n  background: #555;\n  border-radius: 2px;\n}\n\n.btn-vol-up {\n  left: -3px;\n  top: 80px;\n  height: 22px;\n  border-radius: 2px 0 0 2px;\n}\n\n.btn-vol-dn {\n  left: -3px;\n  top: 110px;\n  height: 22px;\n  border-radius: 2px 0 0 2px;\n}\n\n.btn-power {\n  right: -3px;\n  top: 96px;\n  height: 34px;\n  border-radius: 0 2px 2px 0;\n}\n\n/* Image upload area */\n.img-upload-area {\n  border: 2px dashed #d1d9f0;\n  border-radius: 10px;\n  padding: 16px;\n  text-align: center;\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    background 0.15s;\n  background: #f9faff;\n}\n\n.img-upload-area:hover {\n  border-color: #1a56db;\n  background: #ebf2ff;\n}\n\n.img-upload-area input {\n  display: none;\n}\n\n.img-preview {\n  width: 100%;\n  max-height: 100px;\n  object-fit: cover;\n  border-radius: 8px;\n  margin-top: 8px;\n}\n\n.delete-drop-btn {\n  height: 33px;\n  width: 31px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #f09595;\n  border-radius: 6px;\n  background: #fcebeb;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: all 0.2s ease;\n}\n\n.delete-drop-btn:hover {\n  background: #f8d7da;\n  border-color: #e35d5d;\n  transform: scale(1.05);\n}\n\n.delete-drop-btn:active {\n  transform: scale(0.95);\n}\n\n/* *****************qustion Extractor Table********************* */\n.questionTable tr:nth-child(even) {\n  background: transparent;\n}\n\n.questionTable tr:nth-child(odd) {\n  background: transparent;\n}\n\n.questionTable td,\n.questionTable th {\n  padding: 12px 5px;\n  border-width: 1px !important;\n  border-style: solid !important;\n}\n\n.questionTable th {\n  /* background-color: var(--purple); */\n  color: var(--white);\n}\n\n.questionTable {\n  border: 1px solid #fff;\n  /* font-size: 12px;   */\n}\n\n.fc-page-bg {\n  background: linear-gradient(180deg, #f4f6fb 0%, #eef0f7 100%);\n  /* height: 100vh; */\n}\n\n\n.fc-card {\n  background: #ffffff;\n  border: 1px solid #e6e9f0;\n  border-radius: 16px;\n  box-shadow: 0 1px 2px rgba(15, 23, 41, 0.03), 0 12px 32px -16px rgba(15, 23, 41, 0.12);\n  padding: 12px 14px;\n  margin-bottom: 10px;\n}\n\n\n.fc-card-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  /* margin-bottom: 20px; */\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e6e9f0;\n}\n\n.fc-card-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #131a2c;\n  margin: 0 0 4px;\n}\n\n.fc-card-subtitle {\n  font-size: 11.5px;\n  color: #8d94a3;\n  margin: 0;\n}\n\n.fc-card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 10px;\n  padding-top: 16px;\n  border-top: 1px solid #e6e9f0;\n}\n\n.fc-card-compact {\n  padding: 14px 18px;\n  border-radius: 12px;\n}\n\n.mobile-menu-btn {\n  display: none;\n  border: none;\n  background: transparent;\n  padding: 4px;\n  /* margin-right: 15px; */\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #e6e9f0;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n\n.menu-icon {\n  font-size: 26px !important;\n  color: var(--purple);\n}\n\n\n/* .Title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n} */\n\n\n@media (max-width: 576px) {\n  .fc-card {\n    padding: 18px 16px;\n    border-radius: 12px;\n  }\n\n  .fc-card-header {\n    flex-direction: column;\n  }\n}\n\n\n@media screen and (max-width: 1550px) {\n  .detailsdiv {\n    height: calc(100vh - 75px);\n    overflow: auto;\n  }\n}\n\n/* for Publication orders Printing purpose */\n@media print {\n  body {\n    margin: 0;\n  }\n\n  .no-print {\n    display: none !important;\n  }\n\n  .sidebar {\n    display: none !important;\n  }\n\n  .dashboard {\n    width: fit-content;\n  }\n\n  .page-break {\n    page-break-after: always;\n  }\n\n  table {\n    page-break-inside: avoid;\n  }\n}\n\n/* ================= Login Responsive ================= */\n\n@media screen and (max-width: 1400px) {\n  .loginContainer {\n    width: 450px;\n    margin-right: 40px;\n  }\n\n  .loginContainer form {\n    padding: 40px !important;\n  }\n\n  .logoDiv {\n    width: 80px;\n    height: 80px;\n    right: 25px;\n    top: -35px;\n  }\n\n  .loginlogo {\n    width: 60px;\n  }\n}\n\n\n@media screen and (max-width: 1024px) {\n  .border-default span {\n    display: none;\n  }\n\n  .label-wrap>* {\n    width: 100%;\n  }\n\n  *:has(> .label-wrap) {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start !important;\n  }\n\n  *:has(> .label-wrap)>* {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 992px) {\n  .loginBg {\n    justify-content: center;\n    align-items: center;\n    background-size: cover;\n    min-height: 100vh;\n  }\n\n  .loginContainer {\n    width: 420px;\n    margin: 50px auto;\n  }\n\n  .loginContainer form {\n    padding: 35px !important;\n  }\n\n  .loginContainer h3 {\n    font-size: 24px;\n    margin-bottom: 35px !important;\n  }\n\n  .loginContainer label input {\n    padding: 13px 15px;\n    font-size: 15px;\n  }\n\n  .loginContainer label input+span {\n    font-size: 1em;\n  }\n\n  .otpBox {\n    justify-content: center;\n  }\n\n  .label {\n    width: 140px;\n    font-size: 14px;\n  }\n}\n\n.sidebar-close-btn {\n  display: none;\n}\n\n.sidebar-close-btn button {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.15);\n  color: #fff;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.2s ease;\n}\n\n.sidebar-close-btn button:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: rotate(90deg);\n}\n\n@media screen and (max-width: 768px) {\n  .Title {\n    padding-left: 52px !important;\n    font-size: 12px !important;\n  }\n\n  .inputField {\n    width: 100% !important;\n    margin: 8px 0;\n    max-width: 100%;\n  }\n\n  .label-wrap {\n    flex-direction: column;\n    align-items: flex-start !important;\n  }\n\n  .label-wrap>* {\n    width: 100%;\n  }\n\n  *:has(> .label-wrap) {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start !important;\n  }\n\n  *:has(> .label-wrap)>* {\n    width: 100%;\n  }\n\n  /* .label {\n    width: 100%;\n    font-size: 13px;\n    margin-bottom: 4px;\n    white-space: normal;\n    word-break: break-word;\n  } */\n  .loginBg {\n    overflow-y: auto;\n    align-items: flex-start;\n  }\n\n  .loginBg {\n    padding: 20px;\n    background-position: center;\n  }\n\n  .loginContainer {\n    width: 100%;\n    max-width: 380px;\n    margin: 40px auto;\n    border-radius: 15px;\n  }\n\n  .loginContainer form {\n    padding: 30px !important;\n  }\n\n  .logoDiv {\n    width: 75px;\n    height: 75px;\n    right: 20px;\n    top: -35px;\n  }\n\n  .loginlogo {\n    width: 55px;\n  }\n\n  .loginContainer h3 {\n    font-size: 21px;\n    text-align: center;\n  }\n\n  .loginContainer label input {\n    height: 45px;\n    padding-left: 15px;\n  }\n\n  .viewPassword {\n    top: 4px;\n  }\n\n  .btn-primary {\n    width: 100%;\n  }\n\n  .otpBox {\n    width: 100%;\n    overflow-x: auto;\n  }\n\n  .otpBox input {\n    width: 45px !important;\n    height: 45px;\n  }\n\n  .px-5 {\n    padding-left: 25px !important;\n    padding-right: 25px !important;\n  }\n\n  .mobile-menu-btn {\n    display: flex;\n    border: none;\n    background: none;\n  }\n\n  .mobile-menu-btn {\n    display: flex;\n    width: 40px;\n    height: 40px;\n  }\n\n\n\n  .sidebar {\n    position: fixed !important;\n    top: 0;\n    left: -280px !important;\n    width: 250px;\n    height: 100vh;\n    margin: 0;\n    z-index: 9999;\n    transition: 0.3s ease;\n  }\n\n  .sidebar.sidebar-open {\n    left: 0 !important;\n  }\n\n  .sidebar-overlay {\n    display: none;\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.4);\n    backdrop-filter: blur(4px);\n    z-index: 99;\n  }\n\n\n  .sidebar-overlay.show {\n    display: block;\n  }\n\n  .dashboard {\n    width: 100%;\n    margin: 0;\n    padding: 0;\n  }\n\n  .sidebar-close-btn {\n    display: flex;\n    justify-content: flex-end;\n    padding: 10px;\n  }\n}\n\n\n@media screen and (max-width: 480px) {\n  .Title {\n    font-size: 10px !important;\n  }\n\n  .Title span {\n    display: block;\n    max-width: 180px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .label {\n    font-size: 12px;\n  }\n\n  .loginBg {\n    padding: 15px;\n  }\n\n  .loginContainer {\n    max-width: 100%;\n    margin: auto;\n  }\n\n  .loginContainer form {\n    padding: 25px !important;\n  }\n\n  .logoDiv {\n    width: 65px;\n    height: 65px;\n    right: 15px;\n    top: -30px;\n    padding: 7px;\n  }\n\n  .loginlogo {\n    width: 50px;\n  }\n\n  .loginContainer h3 {\n    font-size: 19px;\n    margin-bottom: 25px !important;\n  }\n\n  .loginContainer label input {\n    border-radius: 8px;\n    font-size: 14px;\n  }\n\n  .loginContainer label input+span {\n    left: 16px;\n    font-size: 14px;\n  }\n\n  .otpBox input {\n    width: 38px !important;\n    height: 38px;\n  }\n\n  .otpBox span {\n    margin-left: 8px !important;\n  }\n\n  .loginContainer p {\n    font-size: 14px;\n    text-align: center;\n  }\n}\n\n\n@media screen and (max-height: 700px) {}\n/* BatchNames (Screen/Common/transactionCommon.js): long batch names scroll inside the\n   table cell instead of being cut with \"…\". Max width = the table cell's 320px minus padding. */\n.tc-batchNameScroll {\n  max-width: 292px;\n  overflow: auto;\n  white-space: nowrap;\n  padding-bottom: 2px; /* room for the scroll bar */\n  scrollbar-width: thin;\n  scrollbar-color: #c3c8d4 transparent;\n}\n/* fills its cell instead of the 292px cap; contain keeps a long name from widening the column */\n.tc-batchNameFill {\n  max-width: none;\n  width: 100%;\n  contain: inline-size;\n}\n.tc-batchNameScroll::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n.tc-batchNameScroll::-webkit-scrollbar-thumb {\n  background: #c3c8d4;\n  border-radius: 6px;\n}\n.tc-batchNameScroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
